// import React, { useState, useEffect, useRef } from 'react';
// import { useNavigate, useSearchParams } from 'react-router-dom';
// import { motion, AnimatePresence } from 'framer-motion';
// import {
//     FolderOpen, Search, Briefcase, FolderPlus, Sparkles, Shield, Zap, Upload, X, Check, Eye, Download, Trash2, FileText,
//     User, GraduationCap, Camera, PenTool, CreditCard, BookOpen, Award, Plus, ChevronRight, Info,
//     Lightbulb, Building2, FlaskConical, Target, ClipboardList, Headphones, Folder, Image, File, Edit2
// } from 'lucide-react';
// import { api } from '../../services/api';

// const DocumentPage = () => {
//     const navigate = useNavigate();
//     const [searchParams] = useSearchParams();
//     const [selectedCategory, setSelectedCategory] = useState(searchParams.get('category') || 'document-vault');
//     const [uploadedDocs, setUploadedDocs] = useState({});
//     const [customDocuments, setCustomDocuments] = useState({});
//     const [showAddCustom, setShowAddCustom] = useState(false);
//     const [newCustomDocName, setNewCustomDocName] = useState('');
//     const fileInputRef = useRef(null);
//     const customFileInputRef = useRef(null);
//     const [activeField, setActiveField] = useState(null);
//     const [uploading, setUploading] = useState(false);
//     const [uploadingField, setUploadingField] = useState(null);
//     const [userData, setUserData] = useState(null);
//     const [isProfileFetched, setIsProfileFetched] = useState(
//         localStorage.getItem("isProfileFetched") === "true"
//     );
//     const [imgErrors, setImgErrors] = useState({});
//     const [selectedSection, setSelectedSection] = useState('common');
//     const [userProfessions, setUserProfessions] = useState([]);
//     const professionRefs = useRef({});

//     // File Manager State for Create Folder
//     const [folders, setFolders] = useState(() => {
//         const saved = localStorage.getItem('userFolders');
//         return saved ? JSON.parse(saved) : [];
//     });
//     const [currentFolder, setCurrentFolder] = useState(null);
//     const [showCreateFolderModal, setShowCreateFolderModal] = useState(false);
//     const [newFolderName, setNewFolderName] = useState('');
//     const [selectedFolderColor, setSelectedFolderColor] = useState('blue');
//     const [editingFolder, setEditingFolder] = useState(null);
//     const [showFolderOptions, setShowFolderOptions] = useState(null);
//     const folderFileInputRef = useRef(null);

//     const documentCategories = [
//         {
//             id: 'document-vault',
//             title: 'Document Vault',
//             description: 'Secure storage for all documents',
//             icon: FolderOpen,
//             gradient: 'from-blue-500 to-blue-600',
//             bgGlow: 'bg-blue-500/10',
//             route: '/document-vault'
//         },
//         {
//             id: 'opportunity-seeker',
//             title: 'Opportunity Seeker',
//             description: 'Job & opportunity documents',
//             icon: Search,
//             gradient: 'from-purple-500 to-purple-600',
//             bgGlow: 'bg-purple-500/10',
//             route: '/opportunity-seeker'
//         },
//         {
//             id: 'profession',
//             title: 'Profession',
//             description: 'Certificates & credentials',
//             icon: Briefcase,
//             gradient: 'from-emerald-500 to-emerald-600',
//             bgGlow: 'bg-emerald-500/10',
//             route: '/profession-documents'
//         },
//         {
//             id: 'create-folder',
//             title: 'Create Folder',
//             description: 'Custom organization',
//             icon: FolderPlus,
//             gradient: 'from-amber-500 to-orange-500',
//             bgGlow: 'bg-amber-500/10',
//             route: '/folder-manager'
//         }
//     ];

//     // Document sections for each category - will be populated dynamically
//     const categorySections = {
//         'document-vault': [
//             { id: 'personal', label: 'Personal Identity Documents', icon: User, color: 'blue' },
//             { id: 'education', label: 'Educational & Academic Documents', icon: GraduationCap, color: 'green' },
//             { id: 'custom', label: 'Custom Documents', icon: FolderPlus, color: 'orange' }
//         ],
//         'opportunity-seeker': [
//             { id: 'common', label: 'Opportunity Seeker Documents', icon: FileText, color: 'purple' }
//         ],
//         'profession': [], // Will be populated from userProfessions
//         'create-folder': [
//             { id: 'common', label: 'Common Documents', icon: FileText, color: 'orange' }
//         ]
//     };

//     // Document fields for each section
//     const sectionDocuments = {
//         'document-vault': {
//             'personal': [
//                 { id: 'passport_photo', label: 'Passport Size Photo', icon: Camera, required: true },
//                 { id: 'signature', label: 'Signature', icon: PenTool, required: true },
//                 { id: 'aadhaar', label: 'Aadhaar Card', icon: CreditCard, required: true },
//                 { id: 'pan', label: 'PAN Card', icon: CreditCard, required: false },
//                 { id: 'driving_licence', label: 'Driving Licence', icon: CreditCard, required: false }
//             ],
//             'education': [
//                 { id: '10th_marksheet', label: '10th Marksheet', icon: BookOpen, required: true },
//                 { id: '12th_marksheet', label: '12th Marksheet', icon: BookOpen, required: true },
//                 { id: 'graduation_marksheet', label: 'Graduation Certificate', icon: Award, required: false }
//             ],
//             'custom': [] // Will be populated from customDocuments
//         },
//         'opportunity-seeker': {
//             'common': [
//                 { id: 'resume_cv', label: 'Resume / CV', icon: FileText, required: true },
//                 { id: 'cover_letter', label: 'Cover Letter', icon: FileText, required: false },
//                 { id: 'experience_certificate', label: 'Experience Certificate', icon: Award, required: false },
//                 { id: 'internship_certificate', label: 'Internship Certificate', icon: Award, required: false },
//                 { id: 'project_portfolio', label: 'Project Portfolio', icon: FileText, required: false }
//             ]
//         },
//         'profession': {
//             'common': [
//                 { id: 'offer_letter', label: 'Offer Letter', icon: FileText, required: false },
//                 { id: 'experience_letter', label: 'Experience Letter', icon: Award, required: false },
//                 { id: 'salary_slip', label: 'Salary Slip', icon: FileText, required: false },
//                 { id: 'employee_id', label: 'Employee ID', icon: User, required: false }
//             ]
//         },
//         'create-folder': {
//             'common': [
//                 { id: 'custom_doc1', label: 'Custom Document 1', icon: FileText, required: false },
//                 { id: 'custom_doc2', label: 'Custom Document 2', icon: FileText, required: false }
//             ]
//         }
//     };

//     // Common documents - removed, will be shown in specific sections only
//     const commonDocuments = [];

//     // Profession documents configuration
//     const professionDocuments = {
//         'Student/Exam Aspirant': {
//             icon: GraduationCap,
//             color: 'blue',
//             documents: [
//                 { id: 'student_id', label: 'Student ID Card', icon: User, required: false },
//                 { id: 'admit_card', label: 'Admit Card', icon: FileText, required: false },
//                 { id: 'enrollment_letter', label: 'Enrollment Letter', icon: FileText, required: false },
//                 { id: 'fee_receipt', label: 'Fee Receipt', icon: FileText, required: false }
//             ]
//         },
//         'Working Professional': {
//             icon: Briefcase,
//             color: 'purple',
//             documents: [
//                 { id: 'offer_letter', label: 'Offer Letter', icon: FileText, required: false },
//                 { id: 'experience_letter', label: 'Experience Letter', icon: Award, required: false },
//                 { id: 'salary_slip', label: 'Salary Slip', icon: FileText, required: false },
//                 { id: 'employee_id', label: 'Employee ID', icon: User, required: false }
//             ]
//         },
//         'Founder': {
//             icon: Lightbulb,
//             color: 'orange',
//             documents: [
//                 { id: 'pitchdeck', label: 'Pitchdeck', icon: FileText, required: false },
//                 { id: 'dpiit_certificate', label: 'DPIIT Certificate', icon: Award, required: false },
//                 { id: 'incorporation_certificate', label: 'Incorporation Certificate', icon: Building2, required: false }
//             ]
//         },
//         'Researcher': {
//             icon: FlaskConical,
//             color: 'green',
//             documents: [
//                 { id: 'research_proposal', label: 'Research Proposal (Detailed / PDF)', icon: BookOpen, required: false },
//                 { id: 'research_abstract', label: 'Research Abstract / Executive Summary', icon: FileText, required: false },
//                 { id: 'research_objectives', label: 'Research Objectives & Problem Statement', icon: Target, required: false },
//                 { id: 'research_methodology', label: 'Research Methodology / Approach', icon: ClipboardList, required: false }
//             ]
//         },
//         'Service Center Operator': {
//             icon: Headphones,
//             color: 'cyan',
//             documents: [
//                 { id: 'service_license', label: 'Service License', icon: Award, required: false },
//                 { id: 'business_registration', label: 'Business Registration', icon: Building2, required: false },
//                 { id: 'gst_certificate', label: 'GST Certificate', icon: FileText, required: false },
//                 { id: 'trade_license', label: 'Trade License', icon: FileText, required: false }
//             ]
//         },
//         'Other': {
//             icon: User,
//             color: 'gray',
//             documents: [
//                 { id: 'other_doc1', label: 'Professional Document 1', icon: FileText, required: false },
//                 { id: 'other_doc2', label: 'Professional Document 2', icon: FileText, required: false }
//             ]
//         }
//     };

//     // Scroll to profession section
//     const scrollToProfession = (professionName) => {
//         const elementId = `profession-${professionName.replace(/\s+/g, '-').toLowerCase()}`;
//         const element = document.getElementById(elementId);
//         if (element) {
//             element.scrollIntoView({ behavior: 'smooth', block: 'start' });
//         }
//     };

//     // Scroll to section
//     const scrollToSection = (sectionId) => {
//         const elementId = `section-${sectionId}`;
//         const element = document.getElementById(elementId);
//         if (element) {
//             element.scrollIntoView({ behavior: 'smooth', block: 'start' });
//             setSelectedSection(sectionId);
//         }
//     };

//     useEffect(() => {
//         const category = searchParams.get('category');
//         if (category) {
//             setSelectedCategory(category);
//         }
//     }, [searchParams]);

//     // Get user's selected professions
//     useEffect(() => {
//         const storedProfile = localStorage.getItem('userProfile');
//         if (storedProfile) {
//             try {
//                 const profile = JSON.parse(storedProfile);
//                 if (profile.profession && Array.isArray(profile.profession)) {
//                     setUserProfessions(profile.profession);
//                 }
//             } catch (e) {
//                 console.error('Error parsing profile:', e);
//             }
//         }
//     }, []);

//     useEffect(() => {
//         // Load documents from localStorage first (works without auth)
//         const savedDocs = localStorage.getItem(`uploadedDocs_${selectedCategory}`);
//         if (savedDocs) {
//             try {
//                 const docs = JSON.parse(savedDocs);
//                 setUploadedDocs(docs);
//             } catch (e) {
//                 console.error("Error parsing saved documents:", e);
//             }
//         }

//         // Check if user exists in localStorage before making API call
//         const savedUser = localStorage.getItem("currentUser");

//         // If no user, just continue without fetching profile (page will work without auth)
//         if (!savedUser) {
//             return;
//         }

//         if (!isProfileFetched) {
//             getProfile();
//         } else {
//             if (savedUser) {
//                 try {
//                     const user = JSON.parse(savedUser);
//                     if (user && user.email) {
//                         setUserData(user);
//                         loadUploadedDocs(user);
//                     }
//                     // If invalid user data, just continue without user data (no redirect)
//                 } catch (e) {
//                     console.error("Error parsing user data:", e);
//                     // Continue without user data (no redirect)
//                 }
//             }
//         }
//     }, [isProfileFetched, selectedCategory, selectedSection]);

//     const getProfile = async () => {
//         try {
//             // Double check user exists before API call
//             const savedUser = localStorage.getItem("currentUser");
//             if (!savedUser) {
//                 // No user, just return (page will work without auth)
//                 return;
//             }

//             const response = await api.getProfile();
//             setUserData(response.user_data);
//             setIsProfileFetched(true);
//             localStorage.setItem("isProfileFetched", "true");
//             localStorage.setItem("currentUser", JSON.stringify(response.user_data));
//             loadUploadedDocs(response.user_data);
//         } catch (error) {
//             console.error("Failed to fetch profile:", error);
//             // Don't redirect, just continue without user data
//             // Page will work without authentication
//         }
//     };

//     const loadUploadedDocs = (user) => {
//         const docs = {};
//         const sections = categorySections[selectedCategory] || [];
//         const allFields = [];

//         // Load section-specific documents
//         sections.forEach(section => {
//             const sectionDocs = sectionDocuments[selectedCategory]?.[section.id] || [];
//             allFields.push(...sectionDocs);
//         });

//         // Load common documents
//         allFields.push(...commonDocuments);

//         // Load custom documents
//         const customDocCategories = user?.custom_doc_categories || {};
//         Object.keys(customDocCategories).forEach(fieldKey => {
//             if (customDocCategories[fieldKey] === selectedCategory) {
//                 const customDocId = fieldKey.replace('_file_url', '');
//                 if (!docs[customDocId]) {
//                     docs[customDocId] = {
//                         url: user[fieldKey],
//                         name: fieldKey.replace('_file_url', '').replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase()),
//                         isCustom: true
//                     };
//                 }
//             }
//         });

//         // Load regular documents
//         allFields.forEach(field => {
//             const fieldKey = `${field.id}_file_url`;
//             if (user[fieldKey]) {
//                 docs[field.id] = {
//                     url: user[fieldKey],
//                     name: field.label
//                 };
//             }
//         });

//         setUploadedDocs(docs);
//         // Also save to localStorage for persistence without auth
//         localStorage.setItem(`uploadedDocs_${selectedCategory}`, JSON.stringify(docs));
//     };

//     const getDropboxViewLink = (url) => {
//         if (!url) return "";
//         if (url.includes(".pdf")) {
//             return url.replace("dl=0", "raw=1");
//         }
//         return url.replace("www.dropbox.com", "dl.dropboxusercontent.com");
//     };

//     const getDropboxDownloadLink = (url) => {
//         if (!url) return "";
//         return url
//             .replace("www.dropbox.com", "dl.dropboxusercontent.com")
//             .replace("&dl=0", "&dl=1");
//     };

//     const handleFileUpload = async (fieldId, event) => {
//         const file = event.target.files[0];
//         if (!file) return;

//         setUploading(true);
//         setUploadingField(fieldId);

//         try {
//             if (file.size > 10 * 1024 * 1024) {
//                 throw new Error("File size must be less than 10MB");
//             }

//             const allowedTypes = ["image/jpeg", "image/jpg", "image/png", "application/pdf"];
//             if (!allowedTypes.includes(file.type)) {
//                 throw new Error("Please upload only JPG, PNG, or PDF files");
//             }

//             // Create object URL for immediate display (works without auth)
//             const objectUrl = URL.createObjectURL(file);

//             // Save document to localStorage (works without auth)
//             const newDocs = {
//                 ...uploadedDocs,
//                 [fieldId]: {
//                     url: objectUrl,
//                     name: file.name,
//                     file: file, // Store file reference for persistence
//                     isLocal: true // Mark as local storage
//                 }
//             };
//             setUploadedDocs(newDocs);

//             // Save to localStorage so documents persist without auth
//             localStorage.setItem(`uploadedDocs_${selectedCategory}`, JSON.stringify({
//                 ...newDocs,
//                 // Convert file to base64 for localStorage storage
//                 [fieldId]: {
//                     ...newDocs[fieldId],
//                     url: objectUrl
//                 }
//             }));

//             // Try to upload to server if user is logged in (optional, non-blocking)
//             const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");
//             if (currentUser && currentUser.email) {
//                 try {
//                     const fieldKey = `${fieldId}_file_url`;
//                     const formData = new FormData();
//                     formData.append('email', currentUser.email);
//                     formData.append(fieldKey, file);
//                     const response = await api.updateProfile(formData);
//                     if (response && response.user_data) {
//                         // Update with server URL if available
//                         const updatedDocs = {
//                             ...newDocs,
//                             [fieldId]: {
//                                 ...newDocs[fieldId],
//                                 url: response.user_data[fieldKey] || objectUrl,
//                                 isLocal: false
//                             }
//                         };
//                         setUploadedDocs(updatedDocs);
//                         localStorage.setItem(`uploadedDocs_${selectedCategory}`, JSON.stringify(updatedDocs));
//                     }
//                 } catch (e) {
//                     console.log("Server upload failed, using local storage:", e);
//                     // Continue with local storage - upload already saved above
//                 }
//             }

//             showSuccessMessage('Document uploaded successfully!');
//         } catch (error) {
//             console.error("Upload error:", error);
//             // Show error only for validation errors, not auth errors
//             if (error.message && !error.message.includes("User not found") && !error.message.includes("Please log in")) {
//                 alert(error.message || "Failed to upload document");
//             }
//         } finally {
//             setUploading(false);
//             setUploadingField(null);
//             setActiveField(null);
//         }
//     };

//     const handleCustomFileUpload = async (customDocId, event) => {
//         const file = event.target.files[0];
//         if (!file) return;

//         setUploading(true);
//         setUploadingField(customDocId);

//         try {
//             if (file.size > 10 * 1024 * 1024) {
//                 throw new Error("File size must be less than 10MB");
//             }

//             const allowedTypes = ["image/jpeg", "image/jpg", "image/png", "application/pdf"];
//             if (!allowedTypes.includes(file.type)) {
//                 throw new Error("Please upload only JPG, PNG, or PDF files");
//             }

//             // Create object URL for immediate display (works without auth)
//             const objectUrl = URL.createObjectURL(file);

//             // Save document to localStorage (works without auth)
//             const newDocs = {
//                 ...uploadedDocs,
//                 [customDocId]: {
//                     url: objectUrl,
//                     name: customDocuments[customDocId]?.label || file.name,
//                     isCustom: true,
//                     file: file, // Store file reference for persistence
//                     isLocal: true // Mark as local storage
//                 }
//             };
//             setUploadedDocs(newDocs);

//             // Save to localStorage so documents persist without auth
//             localStorage.setItem(`uploadedDocs_${selectedCategory}`, JSON.stringify({
//                 ...newDocs,
//                 [customDocId]: {
//                     ...newDocs[customDocId],
//                     url: objectUrl
//                 }
//             }));

//             // Try to upload to server if user is logged in (optional, non-blocking)
//             const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");
//             if (currentUser && currentUser.email) {
//                 try {
//                     const fieldKey = `${customDocId}_file_url`;
//                     const formData = new FormData();
//                     formData.append('email', currentUser.email);
//                     formData.append(fieldKey, file);

//                     // Add custom document category
//                     const customDocCategories = {};
//                     customDocCategories[fieldKey] = selectedCategory;
//                     formData.append('custom_doc_categories', JSON.stringify(customDocCategories));

//                     const response = await api.updateProfile(formData);
//                     if (response && response.user_data) {
//                         // Update with server URL if available
//                         const updatedDocs = {
//                             ...newDocs,
//                             [customDocId]: {
//                                 ...newDocs[customDocId],
//                                 url: response.user_data[fieldKey] || objectUrl,
//                                 isLocal: false
//                             }
//                         };
//                         setUploadedDocs(updatedDocs);
//                         localStorage.setItem(`uploadedDocs_${selectedCategory}`, JSON.stringify(updatedDocs));
//                     }
//                 } catch (e) {
//                     console.log("Server upload failed, using local storage:", e);
//                     // Continue with local storage - upload already saved above
//                 }
//             }

//             showSuccessMessage('Document uploaded successfully!');
//         } catch (error) {
//             console.error("Upload error:", error);
//             // Show error only for validation errors, not auth errors
//             if (error.message && !error.message.includes("User not found") && !error.message.includes("Please log in")) {
//                 alert(error.message || "Failed to upload document");
//             }
//         } finally {
//             setUploading(false);
//             setUploadingField(null);
//             setActiveField(null);
//         }
//     };

//     const handleDeleteDoc = async (fieldId) => {
//         if (!window.confirm("Are you sure you want to delete this document?")) return;

//         try {
//             const fieldKey = `${fieldId}_file_url`;
//             const response = await api.deleteDocument(fieldKey);

//             if (response && response.success) {
//                 const updated = { ...uploadedDocs };
//                 delete updated[fieldId];
//                 setUploadedDocs(updated);

//                 // Save to localStorage
//                 localStorage.setItem(`uploadedDocs_${selectedCategory}`, JSON.stringify(updated));

//                 // Remove from custom documents if it was custom
//                 if (customDocuments[fieldId]) {
//                     setCustomDocuments(prev => {
//                         const updated = { ...prev };
//                         delete updated[fieldId];
//                         return updated;
//                     });
//                 }

//                 // Try to refresh profile if user is logged in, but don't fail if not
//                 try {
//                     await getProfile();
//                 } catch (e) {
//                     console.log("Profile refresh skipped:", e);
//                 }
//                 showSuccessMessage('Document deleted successfully!');
//             }
//         } catch (error) {
//             console.error("Delete error:", error);
//             alert(error.message || "Failed to delete document");
//         }
//     };

//     const triggerFileUpload = (fieldId) => {
//         setActiveField(fieldId);
//         fileInputRef.current?.click();
//     };

//     const triggerCustomFileUpload = (customDocId) => {
//         setActiveField(customDocId);
//         customFileInputRef.current?.click();
//     };

//     const handleCategoryClick = (categoryId) => {
//         setSelectedCategory(categoryId);
//         const sections = categorySections[categoryId] || [];
//         if (sections.length > 0) {
//             setSelectedSection(sections[0].id);
//         } else {
//             setSelectedSection('common');
//         }
//         navigate(`/documents?category=${categoryId}`, { replace: true });
//     };

//     const addCustomDocument = () => {
//         if (!newCustomDocName.trim() || newCustomDocName.trim().length < 3) return;

//         const customDocId = `custom_${Date.now()}`;
//         const customDoc = {
//             id: customDocId,
//             label: newCustomDocName.trim(),
//             icon: FileText,
//             isCustom: true
//         };

//         setCustomDocuments(prev => ({
//             ...prev,
//             [customDocId]: customDoc
//         }));

//         setNewCustomDocName('');
//         setShowAddCustom(false);
//     };

//     const removeCustomDocument = (docId) => {
//         setCustomDocuments(prev => {
//             const updated = { ...prev };
//             delete updated[docId];
//             return updated;
//         });
//         if (uploadedDocs[docId]) {
//             handleDeleteDoc(docId);
//         }
//     };

//     // Folder Management Functions
//     const folderColors = [
//         { name: 'blue', bg: 'bg-blue-500', light: 'bg-blue-100' },
//         { name: 'green', bg: 'bg-green-500', light: 'bg-green-100' },
//         { name: 'purple', bg: 'bg-purple-500', light: 'bg-purple-100' },
//         { name: 'orange', bg: 'bg-orange-500', light: 'bg-orange-100' },
//         { name: 'pink', bg: 'bg-pink-500', light: 'bg-pink-100' },
//         { name: 'cyan', bg: 'bg-cyan-500', light: 'bg-cyan-100' }
//     ];

//     const createFolder = () => {
//         if (!newFolderName.trim()) return;
//         const newFolder = {
//             id: Date.now(),
//             name: newFolderName.trim(),
//             files: [],
//             color: selectedFolderColor,
//             createdAt: new Date().toISOString()
//         };
//         const updatedFolders = [...folders, newFolder];
//         setFolders(updatedFolders);
//         localStorage.setItem('userFolders', JSON.stringify(updatedFolders));
//         setNewFolderName('');
//         setSelectedFolderColor('blue');
//         setShowCreateFolderModal(false);
//     };

//     const deleteFolder = (folderId) => {
//         const updatedFolders = folders.filter(f => f.id !== folderId);
//         setFolders(updatedFolders);
//         localStorage.setItem('userFolders', JSON.stringify(updatedFolders));
//         setShowFolderOptions(null);
//         if (currentFolder?.id === folderId) {
//             setCurrentFolder(null);
//         }
//     };

//     const renameFolder = (folderId, newName) => {
//         if (!newName.trim()) return;
//         const updatedFolders = folders.map(f =>
//             f.id === folderId ? { ...f, name: newName.trim() } : f
//         );
//         setFolders(updatedFolders);
//         localStorage.setItem('userFolders', JSON.stringify(updatedFolders));
//         if (currentFolder?.id === folderId) {
//             setCurrentFolder({ ...currentFolder, name: newName.trim() });
//         }
//         setEditingFolder(null);
//     };

//     const handleFolderFileUpload = (event) => {
//         const files = Array.from(event.target.files);
//         if (!currentFolder || files.length === 0) return;

//         const newFiles = files.map(file => ({
//             id: Date.now() + Math.random(),
//             name: file.name,
//             size: (file.size / 1024).toFixed(1) + ' KB',
//             type: file.type,
//             file: file,
//             preview: file.type.startsWith('image/') ? URL.createObjectURL(file) : null,
//             uploadedAt: new Date().toISOString()
//         }));

//         const updatedFolders = folders.map(f =>
//             f.id === currentFolder.id
//                 ? { ...f, files: [...f.files, ...newFiles] }
//                 : f
//         );
//         setFolders(updatedFolders);
//         localStorage.setItem('userFolders', JSON.stringify(updatedFolders));
//         setCurrentFolder(prev => ({
//             ...prev,
//             files: [...prev.files, ...newFiles]
//         }));
//     };

//     const deleteFolderFile = (fileId) => {
//         const updatedFolders = folders.map(f =>
//             f.id === currentFolder.id
//                 ? { ...f, files: f.files.filter(file => file.id !== fileId) }
//                 : f
//         );
//         setFolders(updatedFolders);
//         localStorage.setItem('userFolders', JSON.stringify(updatedFolders));
//         setCurrentFolder(prev => ({
//             ...prev,
//             files: prev.files.filter(file => file.id !== fileId)
//         }));
//     };

//     const getFileIcon = (fileType) => {
//         if (fileType?.startsWith('image/')) return Image;
//         if (fileType?.includes('pdf')) return FileText;
//         return File;
//     };

//     // Load folders from localStorage on mount
//     useEffect(() => {
//         if (selectedCategory === 'create-folder') {
//             const saved = localStorage.getItem('userFolders');
//             if (saved) {
//                 try {
//                     const parsed = JSON.parse(saved);
//                     setFolders(parsed);
//                 } catch (e) {
//                     console.error('Error loading folders:', e);
//                 }
//             }
//         }
//     }, [selectedCategory]);

//     const showSuccessMessage = (message) => {
//         const messageElement = document.createElement('div');
//         messageElement.textContent = message;
//         messageElement.style.cssText = 'position: fixed; top: 70px; right: 45%; padding: 10px; background: #4CAF50; color: white; border-radius: 4px; z-index: 1000;';
//         document.body.appendChild(messageElement);
//         setTimeout(() => document.body.removeChild(messageElement), 3000);
//     };

//     const currentCategory = documentCategories.find(cat => cat.id === selectedCategory);

//     // For profession category, use user's selected professions
//     let sections = categorySections[selectedCategory] || [];
//     if (selectedCategory === 'profession' && userProfessions.length > 0) {
//         sections = userProfessions.map(prof => ({
//             id: prof.replace(/\s+/g, '-').toLowerCase(),
//             label: prof,
//             icon: professionDocuments[prof]?.icon || Briefcase,
//             color: professionDocuments[prof]?.color || 'emerald'
//         }));
//     }

//     // For document-vault, always add custom documents section
//     if (selectedCategory === 'document-vault') {
//         if (!sections.find(s => s.id === 'custom')) {
//             sections.push({ id: 'custom', label: 'Custom Documents', icon: FolderPlus, color: 'orange' });
//         }
//     }

//     // Get documents for current section
//     let currentSectionDocs = [];
//     if (selectedCategory === 'document-vault') {
//         if (selectedSection === 'custom') {
//             currentSectionDocs = Object.values(customDocuments);
//         } else {
//             currentSectionDocs = sectionDocuments[selectedCategory]?.[selectedSection] || [];
//         }
//     } else if (selectedCategory === 'profession' && userProfessions.length > 0) {
//         // For profession, get documents for selected profession section
//         const selectedProf = userProfessions.find(p => p.replace(/\s+/g, '-').toLowerCase() === selectedSection);
//         if (selectedProf) {
//             currentSectionDocs = professionDocuments[selectedProf]?.documents || [];
//         }
//     } else {
//         currentSectionDocs = sectionDocuments[selectedCategory]?.[selectedSection] || [];
//     }

//     // Calculate all documents for the current category
//     let allDocuments = [];
//     if (selectedCategory === 'document-vault') {
//         // Get all documents from personal, education, and custom sections
//         const personalDocs = sectionDocuments[selectedCategory]?.['personal'] || [];
//         const educationDocs = sectionDocuments[selectedCategory]?.['education'] || [];
//         const customDocs = Object.values(customDocuments);
//         allDocuments = [...personalDocs, ...educationDocs, ...customDocs];
//     } else if (selectedCategory === 'profession' && userProfessions.length > 0) {
//         // Get all documents from all selected professions
//         userProfessions.forEach(prof => {
//             const profDocs = professionDocuments[prof]?.documents || [];
//             allDocuments = [...allDocuments, ...profDocs];
//         });
//         // Also include common documents
//         const commonDocs = sectionDocuments[selectedCategory]?.['common'] || [];
//         allDocuments = [...allDocuments, ...commonDocs];
//     } else {
//         // For other categories, get all documents from all sections
//         const categorySections = sectionDocuments[selectedCategory] || {};
//         Object.values(categorySections).forEach(sectionDocs => {
//             allDocuments = [...allDocuments, ...sectionDocs];
//         });
//     }

//     // Count uploaded documents
//     const uploadedCount = Object.keys(uploadedDocs).length;
//     const pendingCount = allDocuments.length - uploadedCount;

//     return (
//         <div className="min-h-screen bg-gradient-to-b from-slate-50 via-white to-blue-50/30">
//             <div className="max-w-7xl mx-auto px-4 pt-20 pb-8 md:pt-24 md:pb-12">
//                 {/* Fixed Category Buttons at Top - Compact Tab Style */}
//                 <div className="fixed top-16 left-0 right-0 z-40 bg-white rounded-b-2xl p-3 shadow-lg border-b border-x border-gray-200 max-w-7xl mx-auto px-4" style={{ backgroundColor: '#ffffff' }}>
//                     <div className="flex flex-wrap items-center justify-center gap-2 md:gap-3">
//                         {documentCategories.map((category) => {
//                             const IconComponent = category.icon;
//                             const isActive = selectedCategory === category.id;

//                             // Get specific colors for each category
//                             const categoryStyles = {
//                                 'document-vault': {
//                                     activeBg: 'bg-blue-50',
//                                     activeText: 'text-blue-700',
//                                     iconColor: 'text-blue-600',
//                                     iconBg: 'bg-blue-100'
//                                 },
//                                 'opportunity-seeker': {
//                                     activeBg: 'bg-purple-50',
//                                     activeText: 'text-purple-700',
//                                     iconColor: 'text-purple-600',
//                                     iconBg: 'bg-purple-100'
//                                 },
//                                 'profession': {
//                                     activeBg: 'bg-emerald-50',
//                                     activeText: 'text-emerald-700',
//                                     iconColor: 'text-emerald-600',
//                                     iconBg: 'bg-emerald-100'
//                                 },
//                                 'create-folder': {
//                                     activeBg: 'bg-amber-50',
//                                     activeText: 'text-amber-700',
//                                     iconColor: 'text-amber-600',
//                                     iconBg: 'bg-amber-100'
//                                 }
//                             };

//                             const style = categoryStyles[category.id] || categoryStyles['document-vault'];

//                             return (
//                                 <button
//                                     key={category.id}
//                                     onClick={() => handleCategoryClick(category.id)}
//                                     className={`group relative flex items-center gap-2.5 px-4 py-2.5 rounded-xl
//                                         transition-all duration-300 ease-out
//                                         ${isActive
//                                             ? `${style.activeBg} ${style.activeText} shadow-md`
//                                             : 'bg-white text-gray-700 hover:bg-gray-50'
//                                         }`}
//                                 >
//                                     {/* Icon */}
//                                     <div className={`w-8 h-8 rounded-lg flex items-center justify-center transition-colors duration-300 ${
//                                         isActive ? style.iconBg : 'bg-gray-100 group-hover:bg-gray-200'
//                                     }`}>
//                                         <IconComponent className={`w-4 h-4 transition-colors duration-300 ${
//                                             isActive ? style.iconColor : 'text-gray-600'
//                                         }`} />
//                     </div>

//                                     {/* Text */}
//                                     <span className={`font-medium text-sm transition-colors duration-300 ${
//                                         isActive ? style.activeText : 'text-gray-700'
//                                     }`}>
//                                         {category.title}
//                                     </span>

//                                     {/* Active indicator chevron */}
//                                     {isActive && (
//                                         <ChevronRight className={`w-4 h-4 ${style.iconColor} transition-all duration-300`} />
//                                     )}
//                                 </button>
//                             );
//                         })}
//                     </div>
//                 </div>

//                 {/* Main Content - Two Column Layout */}
//                 <div className="grid grid-cols-1 lg:grid-cols-4 gap-6 mt-8">
//                     {/* Left Column - Main Content (Scrollable) */}
//                     <div className="lg:col-span-3 space-y-6 overflow-y-auto max-h-[calc(100vh-12rem)] pr-2">
//                         <AnimatePresence mode="wait">
//                             <motion.div
//                                 key={selectedCategory}
//                                 initial={{ opacity: 0, y: 20 }}
//                                 animate={{ opacity: 1, y: 0 }}
//                                 exit={{ opacity: 0, y: -20 }}
//                                 transition={{ duration: 0.3 }}
//                             >
//                                 {/* Document Vault - All sections in one container */}
//                                 {selectedCategory === 'document-vault' ? (
//                                     <div className="bg-white rounded-3xl shadow-xl shadow-blue-900/5 p-6 md:p-8 border border-white/60">
//                                         {/* Main Header */}
//                                         <div className="flex items-center gap-3 mb-6">
//                                             <div className="w-8 h-8 bg-blue-50 rounded-lg flex items-center justify-center">
//                                                 <FileText className="w-5 h-5 text-blue-600" />
//                             </div>
//                                             <div>
//                                                 <h2 className="text-xl font-bold text-gray-900">Upload Documents</h2>
//                                                 <p className="text-sm text-gray-500">We recommend uploading these documents for a smooth application process.</p>
//                     </div>
//                 </div>

//                                         {/* Hidden file inputs */}
//                                         <input
//                                             type="file"
//                                             ref={fileInputRef}
//                                             className="hidden"
//                                             accept="image/*,.pdf"
//                                             onChange={(e) => activeField && handleFileUpload(activeField, e)}
//                                         />
//                                         <input
//                                             type="file"
//                                             ref={customFileInputRef}
//                                             className="hidden"
//                                             accept="image/*,.pdf"
//                                             onChange={(e) => activeField && handleCustomFileUpload(activeField, e)}
//                                         />

//                                         {/* All Sections */}
//                                         <div className="space-y-8">
//                                             {sections.map((section) => {
//                                                 const sectionDocs = section.id === 'custom' 
//                                                     ? Object.values(customDocuments)
//                                                     : sectionDocuments[selectedCategory]?.[section.id] || [];

//                                                 // Skip empty custom section if no custom docs and not adding
//                                                 if (section.id === 'custom' && sectionDocs.length === 0 && !showAddCustom) {
//                                                     return null;
//                                                 }

//                         return (
//                                                     <div
//                                                         key={section.id}
//                                                         id={`section-${section.id}`}
//                                                         className="scroll-mt-24"
//                                                     >
//                                                         {/* Section Header */}
//                                                         <div className="flex items-center gap-3 mb-4">
//                                                             <div className={`w-8 h-8 rounded-lg flex items-center justify-center ${
//                                                                 section.color === 'blue' ? 'bg-blue-50' :
//                                                                 section.color === 'green' ? 'bg-green-50' :
//                                                                 'bg-orange-50'
//                                                             }`}>
//                                                                 <section.icon className={`w-4 h-4 ${
//                                                                     section.color === 'blue' ? 'text-blue-600' :
//                                                                     section.color === 'green' ? 'text-green-600' :
//                                                                     'text-orange-600'
//                                                                 }`} />
//                                                             </div>
//                                                             <h3 className="text-lg font-bold text-gray-900">{section.label}</h3>
//                                                         </div>

//                                                         {/* Document Cards Grid */}
//                                                         <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
//                                                             {sectionDocs.map((doc) => {
//                                                                 const isUploaded = uploadedDocs[doc.id];
//                                                                 const isUploading = uploading && uploadingField === doc.id;
//                                                                 const docUrl = isUploaded ? uploadedDocs[doc.id]?.url : null;
//                                                                 const isImage = docUrl && !docUrl.includes('.pdf');
//                                                                 const imgError = imgErrors[doc.id] || false;
//                                                                 const DocIcon = doc.icon || FileText;

//                                                                 return (
//                                                                     <motion.div
//                                                         key={doc.id}
//                                                         initial={{ opacity: 0, y: 20 }}
//                                                         animate={{ opacity: 1, y: 0 }}
//                                                         transition={{ duration: 0.3 }}
//                                                         className="rounded-xl border border-gray-200 p-3 flex flex-col items-center hover:shadow-lg transition-all duration-300 bg-white"
//                                                     >
//                                                         <div className="mb-3 text-center font-semibold text-gray-800 flex items-center gap-2 justify-center w-full">
//                                                             {doc.label}
//                                                             {doc.required && <span className="text-red-500">*</span>}
//                                                             <Info className="w-3 h-3 text-gray-400 cursor-help" />
//                                                         </div>

//                                                         {isUploaded && docUrl ? (
//                                                             <div className="w-full mb-3">
//                                                                 {isImage && !imgError ? (
//                                                                     <div className="w-full aspect-[3/2] rounded-xl border-2 border-green-200 overflow-hidden bg-gray-50">
//                                                                         <img
//                                                                             src={getDropboxViewLink(docUrl)}
//                                                                             alt={doc.label}
//                                                                             className="w-full h-full object-contain"
//                                                                             onError={() => setImgErrors(prev => ({ ...prev, [doc.id]: true }))}
//                                                                         />
//                                                                     </div>
//                                                                 ) : (
//                                                                     <div className="w-full aspect-[3/2] rounded-xl border-2 border-green-200 bg-gray-50 flex items-center justify-center">
//                                                                         <DocIcon className="w-12 h-12 text-gray-400" />
//                                                                     </div>
//                                                                 )}
//                                                             </div>
//                                                         ) : (
//                                                             <label
//                                                                 onClick={() => {
//                                                                     if (!isUploading) {
//                                                                         if (doc.isCustom) {
//                                                                             triggerCustomFileUpload(doc.id);
//                                                                         } else {
//                                                                             triggerFileUpload(doc.id);
//                                                                         }
//                                                                     }
//                                                                 }}
//                                                                 className={`w-full aspect-[3/2] rounded-xl border-2 border-dashed ${
//                                                                     isUploading
//                                                                         ? 'border-gray-300 bg-gray-50 cursor-not-allowed'
//                                                                         : 'border-green-400 bg-gradient-to-br from-green-50 via-emerald-50/50 to-green-50/30 hover:border-green-500 hover:from-green-100 hover:via-emerald-100/50 hover:to-green-100/30 hover:shadow-lg hover:shadow-green-200/50 cursor-pointer transform hover:scale-[1.02] active:scale-[0.98]'
//                                                                 } flex flex-col items-center justify-center transition-all duration-300 mb-3 group relative overflow-hidden`}
//                                                             >
//                                                                 {!isUploading && (
//                                                                     <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-1000"></div>
//                                                                 )}
//                                                                 {isUploading ? (
//                                                                     <div className="flex flex-col items-center gap-2">
//                                                                         <div className="w-8 h-8 border-2 border-green-500 border-t-transparent rounded-full animate-spin" />
//                                                                         <span className="text-sm text-gray-600 font-medium">Uploading...</span>
//                                                                     </div>
//                                                                 ) : (
//                                                                     <div className="flex flex-col items-center gap-2.5 relative z-10">
//                                                                         <div className="p-3 rounded-full bg-green-100 group-hover:bg-green-200 transition-colors duration-300">
//                                                                             <Upload className="w-5 h-5 text-green-600 group-hover:text-green-700 transition-colors" />
//                                                                         </div>
//                                                                         <span className="text-xs font-semibold text-green-700 group-hover:text-green-800 transition-colors">
//                                                                             Upload {doc.label}
//                                                                         </span>
//                                                                         <span className="text-[10px] text-green-600/70 font-medium">Click or drag & drop</span>
//                                                                     </div>
//                                                                 )}
//                                                             </label>
//                                                         )}

//                                                         <div className="flex items-center gap-2 w-full justify-center">
//                                                             {isUploaded ? (
//                                                                 <>
//                                                                     <a
//                                                                         href={getDropboxViewLink(docUrl)}
//                                                                         target="_blank"
//                                                                         rel="noopener noreferrer"
//                                                                         className="px-3 py-1.5 bg-green-100 text-green-700 rounded-lg text-xs font-medium hover:bg-green-200 transition-colors"
//                                                                     >
//                                                                         View
//                                                                     </a>
//                                                                     <a
//                                                                         href={getDropboxDownloadLink(docUrl)}
//                                                                         download
//                                                                         className="p-2 text-green-600 hover:bg-green-50 rounded-lg transition-colors"
//                                                                         title="Download"
//                                                                     >
//                                                                         <Download className="w-4 h-4" />
//                                                                     </a>
//                             <button
//                                                                         onClick={() => handleDeleteDoc(doc.id)}
//                                                                         className="p-2 text-red-500 hover:bg-red-50 rounded-lg transition-colors"
//                                                                         title="Delete"
//                                                                     >
//                                                                         <Trash2 className="w-4 h-4" />
//                                                                     </button>
//                                                                 </>
//                                                             ) : null}
//                                                         </div>
//                                                     </motion.div>
//                                                 );
//                                             })}
//                                                         </div>

//                                                         {/* Add Custom Document - Only in custom section */}
//                                                         {section.id === 'custom' && (
//                                                             <div className="mt-6">
//                                                 {showAddCustom ? (
//                                                     <div className="flex gap-2">
//                                                         <input
//                                                             type="text"
//                                                             value={newCustomDocName}
//                                                             onChange={(e) => setNewCustomDocName(e.target.value)}
//                                                             placeholder="Enter document name (min 3 characters)"
//                                                             className="flex-1 px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none"
//                                                             onKeyDown={(e) => {
//                                                                 if (e.key === 'Enter') {
//                                                                     addCustomDocument();
//                                                                 } else if (e.key === 'Escape') {
//                                                                     setShowAddCustom(false);
//                                                                     setNewCustomDocName('');
//                                                                 }
//                                                             }}
//                                                             autoFocus
//                                                         />
//                                                         <button
//                                                             onClick={addCustomDocument}
//                                                             disabled={newCustomDocName.trim().length < 3}
//                                                             className="px-4 py-2 bg-blue-600 text-white rounded-lg font-medium hover:bg-blue-700 transition-colors disabled:bg-gray-300 disabled:cursor-not-allowed"
//                                                         >
//                                                             Add
//                                                         </button>
//                                                         <button
//                                                             onClick={() => {
//                                                                 setShowAddCustom(false);
//                                                                 setNewCustomDocName('');
//                                                             }}
//                                                             className="px-4 py-2 bg-gray-200 text-gray-700 rounded-lg font-medium hover:bg-gray-300 transition-colors"
//                                                         >
//                                                             Cancel
//                                                         </button>
//                                     </div>
//                                                 ) : (
//                                                     <button
//                                                         onClick={() => setShowAddCustom(true)}
//                                                         className="flex items-center gap-2 px-4 py-2 bg-orange-500 text-white rounded-lg font-medium hover:bg-orange-600 transition-colors"
//                                                     >
//                                                         <Plus className="w-4 h-4" />
//                                                         Add Custom Document
//                                                     </button>
//                                                 )}
//                                                             </div>
//                                                         )}
//                                                     </div>
//                                                 );
//                                             })}
//                                         </div>
//                                     </div>
//                                 ) : selectedCategory === 'create-folder' ? (
//                                     // File Manager for Create Folder
//                                     <div className="bg-white rounded-3xl shadow-xl shadow-blue-900/5 p-6 md:p-8 border border-white/60">
//                                         {/* Header */}
//                                         <div className="flex items-center justify-between mb-6">
//                                             <div className="flex items-center gap-3">
//                                                 {currentFolder && (
//                                                     <button
//                                                         onClick={() => setCurrentFolder(null)}
//                                                         className="p-2 hover:bg-gray-100 rounded-xl transition-colors"
//                                                     >
//                                                         <ChevronRight className="w-5 h-5 text-gray-600 rotate-180" />
//                                                     </button>
//                                                 )}
//                                                 <div>
//                                                     <h2 className="text-xl font-bold text-gray-900">
//                                                         {currentFolder ? currentFolder.name : 'My Folders'}
//                                                     </h2>
//                                                     <p className="text-sm text-gray-500">
//                                                         {currentFolder
//                                                             ? `${currentFolder.files.length} files`
//                                                             : `${folders.length} folders`
//                                                         }
//                                                     </p>
//                                                 </div>
//                                     </div>

//                                             {!currentFolder ? (
//                                                 <button
//                                                     onClick={() => setShowCreateFolderModal(true)}
//                                                     className="flex items-center gap-2 px-4 py-2.5 bg-amber-600 text-white rounded-xl font-medium hover:bg-amber-700 transition-colors shadow-lg shadow-amber-600/20"
//                                                 >
//                                                     <FolderPlus className="w-4 h-4" />
//                                                     New Folder
//                                                 </button>
//                                             ) : (
//                                                 <button
//                                                     onClick={() => folderFileInputRef.current?.click()}
//                                                     className="flex items-center gap-2 px-4 py-2.5 bg-amber-600 text-white rounded-xl font-medium hover:bg-amber-700 transition-colors shadow-lg shadow-amber-600/20"
//                                                 >
//                                                     <Upload className="w-4 h-4" />
//                                                     Upload Files
//                                                 </button>
//                                             )}
//                                         </div>

//                                         {/* Hidden file input for folder files */}
//                                         <input
//                                             type="file"
//                                             ref={folderFileInputRef}
//                                             className="hidden"
//                                             multiple
//                                             accept="image/*,.pdf,.doc,.docx,.txt"
//                                             onChange={handleFolderFileUpload}
//                                         />

//                                         {/* Folder Grid View or Files View */}
//                                         {!currentFolder ? (
//                                             <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
//                                                 {folders.map((folder) => {
//                                                     const colorClasses = folderColors.find(c => c.name === folder.color) || folderColors[0];

//                                                     return (
//                                                         <div key={folder.id} className="relative group">
//                                                             <button
//                                                                 onClick={() => setCurrentFolder(folder)}
//                                                                 className={`w-full p-6 rounded-2xl ${colorClasses.light} border-2 border-transparent hover:border-gray-300 transition-all hover:shadow-lg active:scale-[0.98]`}
//                                                             >
//                                                                 <div className="flex flex-col items-center gap-3">
//                                                                     <div className={`w-16 h-16 ${colorClasses.bg} rounded-2xl flex items-center justify-center shadow-lg`}>
//                                                                         <FolderOpen className="w-8 h-8 text-white" />
//                                                                     </div>

//                                                                     {editingFolder === folder.id ? (
//                                                                         <input
//                                                                             type="text"
//                                                                             defaultValue={folder.name}
//                                                                             className="text-center text-sm font-medium bg-white px-2 py-1 rounded-lg border focus:outline-none focus:ring-2 focus:ring-amber-500"
//                                                                             autoFocus
//                                                                             onBlur={(e) => renameFolder(folder.id, e.target.value)}
//                                                                             onKeyDown={(e) => {
//                                                                                 if (e.key === 'Enter') {
//                                                                                     renameFolder(folder.id, e.target.value);
//                                                                                 }
//                                                                             }}
//                                                                             onClick={(e) => e.stopPropagation()}
//                                                                         />
//                                                                     ) : (
//                                                                         <span className="text-sm font-medium text-gray-800 truncate max-w-full">
//                                                                             {folder.name}
//                                                                         </span>
//                                                                     )}

//                                                                     <span className="text-xs text-gray-500">
//                                                                         {folder.files.length} files
//                                                                     </span>
//                                                                 </div>
//                                                             </button>

//                                                             {/* Options Menu Button */}
//                                                             <button
//                                                                 onClick={(e) => {
//                                                                     e.stopPropagation();
//                                                                     setShowFolderOptions(showFolderOptions === folder.id ? null : folder.id);
//                                                                 }}
//                                                                 className="absolute top-2 right-2 p-1.5 bg-white/80 rounded-lg opacity-0 group-hover:opacity-100 transition-opacity hover:bg-white shadow-sm"
//                                                             >
//                                                                 <ChevronRight className="w-4 h-4 text-gray-500 rotate-90" />
//                                                             </button>

//                                                             {/* Options Dropdown */}
//                                                             {showFolderOptions === folder.id && (
//                                                                 <div className="absolute top-10 right-2 bg-white rounded-xl shadow-xl border border-gray-100 py-2 z-10 min-w-[140px]">
//                                                                     <button
//                                                                         onClick={(e) => {
//                                                                             e.stopPropagation();
//                                                                             setEditingFolder(folder.id);
//                                                                             setShowFolderOptions(null);
//                                                                         }}
//                                                                         className="w-full px-4 py-2 text-left text-sm text-gray-700 hover:bg-gray-50 flex items-center gap-2"
//                                                                     >
//                                                                         <Edit2 className="w-4 h-4" />
//                                                                         Rename
//                                                                     </button>
//                                                                     <button
//                                                                         onClick={(e) => {
//                                                                             e.stopPropagation();
//                                                                             if (window.confirm('Are you sure you want to delete this folder?')) {
//                                                                                 deleteFolder(folder.id);
//                                                                             }
//                                                                         }}
//                                                                         className="w-full px-4 py-2 text-left text-sm text-red-600 hover:bg-red-50 flex items-center gap-2"
//                                                                     >
//                                                                         <Trash2 className="w-4 h-4" />
//                                                                         Delete
//                                                                     </button>
//                                                                 </div>
//                                                             )}
//                                                         </div>
//                                                     );
//                                                 })}

//                                                 {/* Add Folder Card */}
//                                                 <button
//                                                     onClick={() => setShowCreateFolderModal(true)}
//                                                     className="p-6 rounded-2xl border-2 border-dashed border-gray-200 hover:border-amber-400 hover:bg-amber-50/50 transition-all flex flex-col items-center justify-center gap-3 min-h-[160px]"
//                                                 >
//                                                     <div className="w-16 h-16 bg-gray-100 rounded-2xl flex items-center justify-center">
//                                                         <Plus className="w-8 h-8 text-gray-400" />
//                                                     </div>
//                                                     <span className="text-sm font-medium text-gray-500">Create Folder</span>
//                                                 </button>
//                                             </div>
//                                         ) : (
//                                             /* Files View Inside Folder */
//                                             <div>
//                                                 {currentFolder.files.length === 0 ? (
//                                                     <div className="flex flex-col items-center justify-center py-16">
//                                                         <div className="w-24 h-24 bg-gray-100 rounded-full flex items-center justify-center mb-4">
//                                                             <FolderOpen className="w-12 h-12 text-gray-300" />
//                                                         </div>
//                                                         <h3 className="text-lg font-medium text-gray-600 mb-2">This folder is empty</h3>
//                                                         <p className="text-sm text-gray-400 mb-6">Upload files to get started</p>
//                                                         <button
//                                                             onClick={() => folderFileInputRef.current?.click()}
//                                                             className="flex items-center gap-2 px-6 py-3 bg-amber-600 text-white rounded-xl font-medium hover:bg-amber-700 transition-colors"
//                                                         >
//                                                             <Upload className="w-4 h-4" />
//                                                             Upload Files
//                                                         </button>
//                                                     </div>
//                                                 ) : (
//                                                     <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
//                                                         {currentFolder.files.map((file) => {
//                                                             const FileIcon = getFileIcon(file.type);

//                                                             return (
//                                                                 <div
//                                                                     key={file.id}
//                                                                     className="relative group p-3 rounded-2xl bg-gray-50 hover:bg-gray-100 transition-all"
//                                                                 >
//                                                                     <div className="flex flex-col items-center gap-3">
//                                                                         {file.preview ? (
//                                                                             <img
//                                                                                 src={file.preview}
//                                                                                 alt={file.name}
//                                                                                 className="w-16 h-16 object-cover rounded-xl"
//                                                                             />
//                                                                         ) : (
//                                                                             <div className="w-16 h-16 bg-white rounded-xl flex items-center justify-center shadow-sm">
//                                                                                 <FileText className="w-8 h-8 text-gray-400" />
//                                                                             </div>
//                                                                         )}
//                                                                         <div className="text-center">
//                                                                             <p className="text-sm font-medium text-gray-800 truncate max-w-[120px]">
//                                                                                 {file.name}
//                                                                             </p>
//                                                                             <p className="text-xs text-gray-400">{file.size}</p>
//                                 </div>
//                                                                     </div>

//                                                                     {/* Delete button */}
//                                                                     <button
//                                                                         onClick={() => deleteFolderFile(file.id)}
//                                                                         className="absolute top-2 right-2 p-1.5 bg-red-500 text-white rounded-lg opacity-0 group-hover:opacity-100 transition-opacity hover:bg-red-600"
//                                                                     >
//                                                                         <X className="w-3 h-3" />
//                             </button>
//                                                                 </div>
//                         );
//                     })}

//                                                         {/* Add More Files */}
//                                                         <button
//                                                             onClick={() => folderFileInputRef.current?.click()}
//                                                             className="p-3 rounded-2xl border-2 border-dashed border-gray-200 hover:border-amber-400 hover:bg-amber-50/50 transition-all flex flex-col items-center justify-center gap-2 min-h-[140px]"
//                                                         >
//                                                             <Upload className="w-8 h-8 text-gray-400" />
//                                                             <span className="text-sm font-medium text-gray-500">Add Files</span>
//                                                         </button>
//                 </div>
//                                                 )}
//                                             </div>
//                                         )}
//                                     </div>
//                                 ) : selectedCategory === 'profession' && userProfessions.length > 0 ? (
//                                     // Profession-wise document sections
//                                     <div className="space-y-8">
//                                         {userProfessions.map((professionName) => {
//                                             const profConfig = professionDocuments[professionName];
//                                             if (!profConfig) return null;

//                                             const profId = professionName.replace(/\s+/g, '-').toLowerCase();
//                                             const profDocs = profConfig.documents || [];
//                                             const ProfIcon = profConfig.icon;

//                                             return (
//                                                 <div
//                                                     key={profId}
//                                                     id={`profession-${profId}`}
//                                                     className="bg-white rounded-3xl shadow-xl shadow-blue-900/5 p-6 md:p-8 border border-white/60 scroll-mt-24"
//                                                 >
//                                                     <div className="flex items-center gap-3 mb-6">
//                                                         <div className={`w-10 h-10 rounded-lg flex items-center justify-center ${
//                                                             profConfig.color === 'blue' ? 'bg-blue-50' :
//                                                             profConfig.color === 'green' ? 'bg-green-50' :
//                                                             profConfig.color === 'purple' ? 'bg-purple-50' :
//                                                             profConfig.color === 'orange' ? 'bg-orange-50' :
//                                                             profConfig.color === 'cyan' ? 'bg-cyan-50' :
//                                                             'bg-gray-50'
//                                                         }`}>
//                                                             <ProfIcon className={`w-5 h-5 ${
//                                                                 profConfig.color === 'blue' ? 'text-blue-600' :
//                                                                 profConfig.color === 'green' ? 'text-green-600' :
//                                                                 profConfig.color === 'purple' ? 'text-purple-600' :
//                                                                 profConfig.color === 'orange' ? 'text-orange-600' :
//                                                                 profConfig.color === 'cyan' ? 'text-cyan-600' :
//                                                                 'text-gray-600'
//                                                             }`} />
//                                 </div>
//                                                         <div>
//                                                             <h2 className="text-xl font-bold text-gray-900">{professionName}</h2>
//                                                             <p className="text-sm text-gray-500">Upload documents for {professionName}</p>
//                                                         </div>
//                                                     </div>

//                                                     {/* Document Cards Grid for this profession */}
//                                                     <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
//                                                         {profDocs.map((doc) => {
//                                                             const isUploaded = uploadedDocs[doc.id];
//                                                             const isUploading = uploading && uploadingField === doc.id;
//                                                             const docUrl = isUploaded ? uploadedDocs[doc.id]?.url : null;
//                                                             const isImage = docUrl && !docUrl.includes('.pdf');
//                                                             const imgError = imgErrors[doc.id] || false;
//                                                             const DocIcon = doc.icon || FileText;

//                                                             return (
//                                                                 <motion.div
//                                                                     key={doc.id}
//                                                                     initial={{ opacity: 0, y: 20 }}
//                                                                     animate={{ opacity: 1, y: 0 }}
//                                                                     transition={{ duration: 0.3 }}
//                                                                     className="rounded-xl border border-gray-200 p-3 flex flex-col items-center hover:shadow-lg transition-all duration-300 bg-white"
//                                                                 >
//                                                                     <div className="mb-3 text-center font-semibold text-gray-800 flex items-center gap-2 justify-center w-full">
//                                                                         {doc.label}
//                                                                         {doc.required && <span className="text-red-500">*</span>}
//                                                                         <Info className="w-3 h-3 text-gray-400 cursor-help" />
//                                                                     </div>

//                                                                     {isUploaded && docUrl ? (
//                                                                         <div className="w-full mb-3">
//                                                                             {isImage && !imgError ? (
//                                                                                 <div className="w-full aspect-[2/1] rounded-xl border-2 border-green-200 overflow-hidden bg-gray-50">
//                                                                                     <img
//                                                                                         src={getDropboxViewLink(docUrl)}
//                                                                                         alt={doc.label}
//                                                                                         className="w-full h-full object-contain"
//                                                                                         onError={() => setImgErrors(prev => ({ ...prev, [doc.id]: true }))}
//                                                                                     />
//                                                                                 </div>
//                                                                             ) : (
//                                                                                 <div className="w-full aspect-[3/2] rounded-xl border-2 border-green-200 bg-gray-50 flex items-center justify-center">
//                                                                                     <DocIcon className="w-12 h-12 text-gray-400" />
//                                                                                 </div>
//                                                                             )}
//                                                                         </div>
//                                                                     ) : (
//                                                                         <label
//                                                                             onClick={() => {
//                                                                                 if (!isUploading) {
//                                                                                     triggerFileUpload(doc.id);
//                                                                                 }
//                                                                             }}
//                                                                             className={`w-full aspect-[3/2] rounded-xl border-2 border-dashed ${
//                                                                                 isUploading
//                                                                                     ? 'border-gray-300 bg-gray-50 cursor-not-allowed'
//                                                                                     : 'border-green-400 bg-gradient-to-br from-green-50 via-emerald-50/50 to-green-50/30 hover:border-green-500 hover:from-green-100 hover:via-emerald-100/50 hover:to-green-100/30 hover:shadow-lg hover:shadow-green-200/50 cursor-pointer transform hover:scale-[1.02] active:scale-[0.98]'
//                                                                             } flex flex-col items-center justify-center transition-all duration-300 mb-3 group relative overflow-hidden`}
//                                                                         >
//                                                                             {!isUploading && (
//                                                                                 <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-1000"></div>
//                                                                             )}
//                                                                             {isUploading ? (
//                                                                                 <div className="flex flex-col items-center gap-2">
//                                                                                     <div className="w-8 h-8 border-2 border-green-500 border-t-transparent rounded-full animate-spin" />
//                                                                                     <span className="text-sm text-gray-600 font-medium">Uploading...</span>
//                                                                                 </div>
//                                                                             ) : (
//                                                                                 <div className="flex flex-col items-center gap-2.5 relative z-10">
//                                                                                     <div className="p-3 rounded-full bg-green-100 group-hover:bg-green-200 transition-colors duration-300">
//                                                                                         <Upload className="w-5 h-5 text-green-600 group-hover:text-green-700 transition-colors" />
//                                                                                     </div>
//                                                                                     <span className="text-xs font-semibold text-green-700 group-hover:text-green-800 transition-colors">
//                                                                                         Upload {doc.label}
//                             </span>
//                                                                                     <span className="text-[10px] text-green-600/70 font-medium">Click or drag & drop</span>
//                         </div>
//                                                                             )}
//                                                                         </label>
//                                                                     )}

//                                                                     <div className="flex items-center gap-2 w-full justify-center">
//                                                                         {isUploaded ? (
//                                                                             <>
//                                                                                 <a
//                                                                                     href={getDropboxViewLink(docUrl)}
//                                                                                     target="_blank"
//                                                                                     rel="noopener noreferrer"
//                                                                                     className="px-3 py-1.5 bg-green-100 text-green-700 rounded-lg text-xs font-medium hover:bg-green-200 transition-colors"
//                                                                                 >
//                                                                                     View
//                                                                                 </a>
//                                                                                 <a
//                                                                                     href={getDropboxDownloadLink(docUrl)}
//                                                                                     download
//                                                                                     className="p-2 text-green-600 hover:bg-green-50 rounded-lg transition-colors"
//                                                                                     title="Download"
//                                                                                 >
//                                                                                     <Download className="w-4 h-4" />
//                                                                                 </a>
//                                                                                 <button
//                                                                                     onClick={() => handleDeleteDoc(doc.id)}
//                                                                                     className="p-2 text-red-500 hover:bg-red-50 rounded-lg transition-colors"
//                                                                                     title="Delete"
//                                                                                 >
//                                                                                     <Trash2 className="w-4 h-4" />
//                             </button>
//                                                                             </>
//                                                                         ) : null}
//                                                                     </div>
//                                                                 </motion.div>
//                         );
//                     })}
//                 </div>
//                                                 </div>
//                                             );
//                                         })}
//                                     </div>
//                                 ) : (
//                                     // Regular document upload section for Opportunity Seeker and other categories
//                                     <div className="bg-white rounded-3xl shadow-xl shadow-blue-900/5 p-6 md:p-8 border border-white/60">
//                                         <div className="flex items-center gap-3 mb-2">
//                                             <div className="w-10 h-10 bg-blue-50 rounded-lg flex items-center justify-center">
//                                                 <FileText className="w-5 h-5 text-blue-600" />
//                                             </div>
//                                             <div>
//                                                 <h2 className="text-xl font-bold text-gray-900">Upload Documents</h2>
//                                                 <p className="text-sm text-gray-500">We recommend uploading these documents for a smooth application process.</p>
//                                             </div>
//                                         </div>

//                                         {/* Hidden file inputs */}
//                                         <input
//                                             type="file"
//                                             ref={fileInputRef}
//                                             className="hidden"
//                                             accept="image/*,.pdf"
//                                             onChange={(e) => activeField && handleFileUpload(activeField, e)}
//                                         />
//                                         <input
//                                             type="file"
//                                             ref={customFileInputRef}
//                                             className="hidden"
//                                             accept="image/*,.pdf"
//                                             onChange={(e) => activeField && handleCustomFileUpload(activeField, e)}
//                                         />

//                                     {/* Hidden file inputs */}
//                                     <input
//                                         type="file"
//                                         ref={fileInputRef}
//                                         className="hidden"
//                                         accept="image/*,.pdf"
//                                         onChange={(e) => activeField && handleFileUpload(activeField, e)}
//                                     />
//                                     <input
//                                         type="file"
//                                         ref={customFileInputRef}
//                                         className="hidden"
//                                         accept="image/*,.pdf"
//                                         onChange={(e) => activeField && handleCustomFileUpload(activeField, e)}
//                                     />

//                                     {/* Document Cards Grid */}
//                                     <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-6">
//                                         {currentSectionDocs.map((doc) => {
//                                             const isUploaded = uploadedDocs[doc.id];
//                                             const isUploading = uploading && uploadingField === doc.id;
//                                             const docUrl = isUploaded ? uploadedDocs[doc.id]?.url : null;
//                                             const isImage = docUrl && !docUrl.includes('.pdf');
//                                             const imgError = imgErrors[doc.id] || false;
//                                             const DocIcon = doc.icon || FileText;

//                                             return (
//                                                 <motion.div
//                                                     key={doc.id}
//                                                     initial={{ opacity: 0, y: 20 }}
//                                                     animate={{ opacity: 1, y: 0 }}
//                                                     transition={{ duration: 0.3 }}
//                                                     className="rounded-xl border border-gray-200 p-3 flex flex-col items-center hover:shadow-lg transition-all duration-300 bg-white"
//                                                 >
//                                                     {/* Title with info icon */}
//                                                     <div className="mb-3 text-center font-semibold text-gray-800 flex items-center gap-2 justify-center w-full">
//                                                         {doc.label}
//                                                         {doc.required && <span className="text-red-500">*</span>}
//                                                         <div className="relative inline-block">
//                                                             <Info className="w-3 h-3 text-gray-400 cursor-help" />
//                                                         </div>
//                                                     </div>

//                                                     {/* Upload Area or Preview */}
//                                                     {isUploaded && docUrl ? (
//                                                         <div className="w-full mb-3">
//                                                             {isImage && !imgError ? (
//                                                                 <div className="w-full aspect-[3/2] rounded-xl border-2 border-green-200 overflow-hidden bg-gray-50">
//                                                                     <img
//                                                                         src={getDropboxViewLink(docUrl)}
//                                                                         alt={doc.label}
//                                                                         className="w-full h-full object-contain"
//                                                                         onError={() => setImgErrors(prev => ({ ...prev, [doc.id]: true }))}
//                                                                     />
//                                                                 </div>
//                                                             ) : (
//                                                                 <div className="w-full aspect-[3/2] rounded-xl border-2 border-green-200 bg-gray-50 flex items-center justify-center">
//                                                                     <DocIcon className="w-12 h-12 text-gray-400" />
//                                                                 </div>
//                                                             )}
//                                                         </div>
//                                                     ) : (
//                                                         <label
//                                                             onClick={() => {
//                                                                 if (!isUploading) {
//                                                                     if (doc.isCustom) {
//                                                                         triggerCustomFileUpload(doc.id);
//                                                                     } else {
//                                                                         triggerFileUpload(doc.id);
//                                                                     }
//                                                                 }
//                                                             }}
//                                                             className={`w-full aspect-[3/2] rounded-xl border-2 border-dashed ${
//                                                                 isUploading
//                                                                     ? 'border-gray-300 bg-gray-50 cursor-not-allowed'
//                                                                     : 'border-green-400 bg-gradient-to-br from-green-50 via-emerald-50/50 to-green-50/30 hover:border-green-500 hover:from-green-100 hover:via-emerald-100/50 hover:to-green-100/30 hover:shadow-lg hover:shadow-green-200/50 cursor-pointer transform hover:scale-[1.02] active:scale-[0.98]'
//                                                             } flex flex-col items-center justify-center transition-all duration-300 mb-3 group relative overflow-hidden`}
//                                                         >
//                                                             {!isUploading && (
//                                                                 <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-1000"></div>
//                                                             )}
//                                                             {isUploading ? (
//                                                                 <div className="flex flex-col items-center gap-2">
//                                                                     <div className="w-8 h-8 border-2 border-green-500 border-t-transparent rounded-full animate-spin" />
//                                                                     <span className="text-sm text-gray-600 font-medium">Uploading...</span>
//                                                                 </div>
//                                                             ) : (
//                                                                 <div className="flex flex-col items-center gap-2.5 relative z-10">
//                                                                     <div className="p-3 rounded-full bg-green-100 group-hover:bg-green-200 transition-colors duration-300">
//                                                                         <Upload className="w-5 h-5 text-green-600 group-hover:text-green-700 transition-colors" />
//                                                                     </div>
//                                                                     <span className="text-xs font-semibold text-green-700 group-hover:text-green-800 transition-colors">
//                                                                         Upload {doc.label}
//                                                                     </span>
//                                                                     <span className="text-[10px] text-green-600/70 font-medium">Click or drag & drop</span>
//                                                                 </div>
//                                                             )}
//                                                         </label>
//                                                     )}

//                                                     {/* Action Buttons */}
//                                                     <div className="flex items-center gap-2 w-full justify-center">
//                                                         {isUploaded ? (
//                                                             <>
//                                                                 <a
//                                                                     href={getDropboxViewLink(docUrl)}
//                                                                     target="_blank"
//                                                                     rel="noopener noreferrer"
//                                                                     className="px-3 py-1.5 bg-green-100 text-green-700 rounded-lg text-xs font-medium hover:bg-green-200 transition-colors"
//                                                                 >
//                                                                     View
//                                                                 </a>
//                                                                 <a
//                                                                     href={getDropboxDownloadLink(docUrl)}
//                                                                     download
//                                                                     className="p-2 text-green-600 hover:bg-green-50 rounded-lg transition-colors"
//                                                                     title="Download"
//                                                                 >
//                                                                     <Download className="w-4 h-4" />
//                                                                 </a>
//                             <button
//                                                                     onClick={() => handleDeleteDoc(doc.id)}
//                                                                     className="p-2 text-red-500 hover:bg-red-50 rounded-lg transition-colors"
//                                                                     title="Delete"
//                                                                 >
//                                                                     <Trash2 className="w-4 h-4" />
//                             </button>
//                                                             </>
//                                                         ) : null}
//                                                     </div>
//                                                 </motion.div>
//                                             );
//                                         })}
//                                     </div>

//                                     {/* Add Custom Document */}
//                                     <div className="mt-6">
//                                         {showAddCustom ? (
//                                             <div className="flex gap-2">
//                                                 <input
//                                                     type="text"
//                                                     value={newCustomDocName}
//                                                     onChange={(e) => setNewCustomDocName(e.target.value)}
//                                                     placeholder="Enter document name (min 3 characters)"
//                                                     className="flex-1 px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none"
//                                                     onKeyDown={(e) => {
//                                                         if (e.key === 'Enter') {
//                                                             addCustomDocument();
//                                                         } else if (e.key === 'Escape') {
//                                                             setShowAddCustom(false);
//                                                             setNewCustomDocName('');
//                                                         }
//                                                     }}
//                                                     autoFocus
//                                                 />
//                             <button
//                                                     onClick={addCustomDocument}
//                                                     disabled={newCustomDocName.trim().length < 3}
//                                                     className="px-4 py-2 bg-blue-600 text-white rounded-lg font-medium hover:bg-blue-700 transition-colors disabled:bg-gray-300 disabled:cursor-not-allowed"
//                                                 >
//                                                     Add
//                             </button>
//                             <button
//                                                     onClick={() => {
//                                                         setShowAddCustom(false);
//                                                         setNewCustomDocName('');
//                                                     }}
//                                                     className="px-4 py-2 bg-gray-200 text-gray-700 rounded-lg font-medium hover:bg-gray-300 transition-colors"
//                                                 >
//                                                     Cancel
//                             </button>
//                         </div>
//                                         ) : (
//                                             <button
//                                                 onClick={() => setShowAddCustom(true)}
//                                                 className="flex items-center gap-2 px-4 py-2 bg-orange-500 text-white rounded-lg font-medium hover:bg-orange-600 transition-colors"
//                                             >
//                                                 <Plus className="w-4 h-4" />
//                                                 Add Custom Document
//                             </button>
//                                         )}
//                     </div>
//                                 </div>
//                                 )}
//                             </motion.div>
//                         </AnimatePresence>
//                 </div>

//                     {/* Right Column - Side Panel (Fixed/Sticky) */}
//                     <div className="lg:col-span-1">
//                         <div className="bg-white rounded-3xl shadow-xl shadow-blue-900/5 p-6 border border-white/60 sticky top-28 h-fit">
//                             <h3 className="text-lg font-bold text-gray-900 mb-4">Document Categories</h3>

//                             <div className="space-y-3">
//                                 {/* Category-specific sections */}
//                                 {selectedCategory === 'profession' && userProfessions.length > 0 ? (
//                                     // Show user's selected professions
//                                     userProfessions.map((professionName) => {
//                                         const profConfig = professionDocuments[professionName];
//                                         if (!profConfig) return null;

//                                         const ProfIcon = profConfig.icon;
//                                         const profId = professionName.replace(/\s+/g, '-').toLowerCase();
//                                         const iconColorClasses = {
//                                             blue: 'text-blue-600',
//                                             green: 'text-green-600',
//                                             purple: 'text-purple-600',
//                                             emerald: 'text-emerald-600',
//                                             orange: 'text-orange-600',
//                                             cyan: 'text-cyan-600',
//                                             gray: 'text-gray-600'
//                                         };
//                                         const bgColorClasses = {
//                                             blue: 'bg-blue-50 hover:bg-blue-100',
//                                             green: 'bg-green-50 hover:bg-green-100',
//                                             purple: 'bg-purple-50 hover:bg-purple-100',
//                                             emerald: 'bg-emerald-50 hover:bg-emerald-100',
//                                             orange: 'bg-orange-50 hover:bg-orange-100',
//                                             cyan: 'bg-cyan-50 hover:bg-cyan-100',
//                                             gray: 'bg-gray-50 hover:bg-gray-100'
//                                         };

//                                         return (
//                                             <div
//                                                 key={profId}
//                                                 onClick={() => scrollToProfession(professionName)}
//                                                 className={`p-3 rounded-lg transition-colors cursor-pointer ${
//                                                     bgColorClasses[profConfig.color] || 'bg-gray-50 hover:bg-gray-100'
//                                                 }`}
//                                             >
//                                                 <div className="flex items-center gap-3">
//                                                     <ProfIcon className={`w-5 h-5 ${iconColorClasses[profConfig.color] || 'text-gray-600'}`} />
//                                                     <div className="flex-1">
//                                                         <p className="font-medium text-gray-800 text-sm">{professionName}</p>
//                                                         <p className="text-xs text-gray-500">Upload specific documents for this role.</p>
//                                                     </div>
//                                                     <ChevronRight className="w-4 h-4 text-gray-400" />
//                                                 </div>
//                                             </div>
//                                         );
//                                     })
//                                 ) : (
//                                     // Show regular sections for other categories
//                                     sections.map((section) => {
//                                         const SectionIcon = section.icon;
//                                         const isActive = selectedSection === section.id;
//                                         const bgColorClasses = {
//                                             blue: isActive ? 'bg-blue-50 hover:bg-blue-100' : 'bg-gray-50 hover:bg-gray-100',
//                                             green: isActive ? 'bg-green-50 hover:bg-green-100' : 'bg-gray-50 hover:bg-gray-100',
//                                             purple: isActive ? 'bg-purple-50 hover:bg-purple-100' : 'bg-gray-50 hover:bg-gray-100',
//                                             emerald: isActive ? 'bg-emerald-50 hover:bg-emerald-100' : 'bg-gray-50 hover:bg-gray-100',
//                                             orange: isActive ? 'bg-orange-50 hover:bg-orange-100' : 'bg-gray-50 hover:bg-gray-100'
//                                         };
//                                         const iconColorClasses = {
//                                             blue: 'text-blue-600',
//                                             green: 'text-green-600',
//                                             purple: 'text-purple-600',
//                                             emerald: 'text-emerald-600',
//                                             orange: 'text-orange-600'
//                                         };
//                                         return (
//                                             <div
//                                                 key={section.id}
//                                                 onClick={() => {
//                                                     if (section.id === 'custom' && Object.keys(customDocuments).length === 0 && !showAddCustom) {
//                                                         setShowAddCustom(true);
//                                                     }
//                                                     scrollToSection(section.id);
//                                                 }}
//                                                 className={`p-3 rounded-lg transition-colors cursor-pointer ${
//                                                     bgColorClasses[section.color] || 'bg-gray-50 hover:bg-gray-100'
//                                                 }`}
//                                             >
//                                                 <div className="flex items-center gap-3">
//                                                     <SectionIcon className={`w-5 h-5 ${iconColorClasses[section.color] || 'text-gray-600'}`} />
//                                                     <div className="flex-1">
//                                                         <p className="font-medium text-gray-800 text-sm">{section.label}</p>
//                                                         <p className="text-xs text-gray-500">Upload specific documents for this role.</p>
//                                                     </div>
//                                                     <ChevronRight className="w-4 h-4 text-gray-400" />
//                                                 </div>
//                                             </div>
//                                         );
//                                     })
//                                 )}

//                                 {/* Custom Documents */}
//                                 {Object.keys(customDocuments).length > 0 && (
//                                     <div className="p-3 rounded-lg bg-orange-50 hover:bg-orange-100 transition-colors">
//                                         <div className="flex items-center gap-3">
//                                             <FolderPlus className="w-5 h-5 text-orange-600" />
//                                             <div className="flex-1">
//                                                 <p className="font-medium text-gray-800 text-sm">Custom Documents</p>
//                                                 <p className="text-xs text-gray-500">{Object.keys(customDocuments).length} custom document(s)</p>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 )}
//                             </div>

//                             {/* Summary */}
//                             <div className="mt-6 pt-6 border-t border-gray-200">
//                                 <div className="flex items-center gap-2 text-sm text-gray-600 mb-2">
//                                     <FileText className="w-4 h-4" />
//                                     <span>{uploadedCount} Documents Uploaded</span>
//                                 </div>
//                                 <div className="flex items-center gap-2 text-sm text-gray-600">
//                                     <FileText className="w-4 h-4" />
//                                     <span>{pendingCount} Documents Pending</span>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>

//                 {/* Security Banner */}
//                 <div className="mt-8 flex justify-center">
//                     <div className="inline-flex items-center gap-3 px-6 py-3 bg-emerald-50 border border-emerald-200 rounded-full">
//                         <Shield className="w-5 h-5 text-emerald-600" />
//                         <span className="text-sm font-medium text-emerald-700">
//                             Your data is secured, safe, and always in your control.
//                         </span>
//                     </div>
//                 </div>

//                 {/* Create Folder Modal */}
//                 {showCreateFolderModal && (
//                     <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-3">
//                         <div className="bg-white rounded-3xl p-6 w-full max-w-md shadow-2xl">
//                             <div className="flex items-center justify-between mb-6">
//                                 <h2 className="text-xl font-bold text-gray-900">Create New Folder</h2>
//                                 <button
//                                     onClick={() => setShowCreateFolderModal(false)}
//                                     className="p-2 hover:bg-gray-100 rounded-xl transition-colors"
//                                 >
//                                     <X className="w-5 h-5 text-gray-500" />
//                                 </button>
//                             </div>

//                             <div className="space-y-4">
//                                 <div>
//                                     <label className="block text-sm font-medium text-gray-700 mb-2">
//                                         Folder Name
//                                     </label>
//                                     <input
//                                         type="text"
//                                         value={newFolderName}
//                                         onChange={(e) => setNewFolderName(e.target.value)}
//                                         placeholder="Enter folder name"
//                                         className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:ring-2 focus:ring-amber-500/20 focus:border-amber-500 outline-none transition-all"
//                                         autoFocus
//                                         onKeyDown={(e) => {
//                                             if (e.key === 'Enter') {
//                                                 createFolder();
//                                             }
//                                         }}
//                                     />
//                                 </div>

//                                 <div>
//                                     <label className="block text-sm font-medium text-gray-700 mb-2">
//                                         Folder Color
//                                     </label>
//                                     <div className="flex gap-3">
//                                         {folderColors.map((color) => (
//                                             <button
//                                                 key={color.name}
//                                                 onClick={() => setSelectedFolderColor(color.name)}
//                                                 className={`w-10 h-10 rounded-xl ${color.bg} transition-all ${selectedFolderColor === color.name
//                                                         ? 'ring-4 ring-offset-2 ring-gray-300 scale-110'
//                                                         : 'hover:scale-105'
//                                                     }`}
//                                             />
//                                         ))}
//                                     </div>
//                                 </div>
//                             </div>

//                             <div className="flex gap-3 mt-6">
//                                 <button
//                                     onClick={() => {
//                                         setShowCreateFolderModal(false);
//                                         setNewFolderName('');
//                                         setSelectedFolderColor('blue');
//                                     }}
//                                     className="flex-1 px-4 py-3 rounded-xl border border-gray-200 text-gray-600 font-medium hover:bg-gray-50 transition-colors"
//                                 >
//                                     Cancel
//                                 </button>
//                                 <button
//                                     onClick={createFolder}
//                                     disabled={!newFolderName.trim()}
//                                     className="flex-1 px-4 py-3 rounded-xl bg-amber-600 text-white font-medium hover:bg-amber-700 transition-colors disabled:bg-gray-200 disabled:text-gray-400"
//                                 >
//                                     Create Folder
//                                 </button>
//                             </div>
//                         </div>
//                     </div>
//                 )}
//             </div>
//         </div>
//     );
// };

// export default DocumentPage;




import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import {
    FolderOpen, Search, Briefcase, FolderPlus, Sparkles, Shield, Zap, Upload, X, Check, Eye, Download, Trash2, FileText,
    User, GraduationCap, Camera, PenTool, CreditCard, BookOpen, Award, Plus, ChevronRight, Info,
    Lightbulb, Building2, FlaskConical, Target, ClipboardList, Headphones, Folder, Image, File, Edit2
} from 'lucide-react';
import { api } from '../../services/api';

const DocumentPage = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const [selectedCategory, setSelectedCategory] = useState(searchParams.get('category') || 'document-vault');
    const [uploadedDocs, setUploadedDocs] = useState({});
    const [customDocuments, setCustomDocuments] = useState({});
    const [showAddCustom, setShowAddCustom] = useState(false);
    const [newCustomDocName, setNewCustomDocName] = useState('');
    const fileInputRef = useRef(null);
    const customFileInputRef = useRef(null);
    const [activeField, setActiveField] = useState(null);
    const [uploading, setUploading] = useState(false);
    const [uploadingField, setUploadingField] = useState(null);
    const [userData, setUserData] = useState(null);
    const [isProfileFetched, setIsProfileFetched] = useState(
        localStorage.getItem("isProfileFetched") === "true"
    );
    const [imgErrors, setImgErrors] = useState({});
    const [selectedSection, setSelectedSection] = useState('common');
    const [userProfessions, setUserProfessions] = useState([]);
    const professionRefs = useRef({});

    // File Manager State for Create Folder
    const [folders, setFolders] = useState(() => {
        const saved = localStorage.getItem('userFolders');
        return saved ? JSON.parse(saved) : [];
    });
    const [currentFolder, setCurrentFolder] = useState(null);
    const [showCreateFolderModal, setShowCreateFolderModal] = useState(false);
    const [newFolderName, setNewFolderName] = useState('');
    const [selectedFolderColor, setSelectedFolderColor] = useState('blue');
    const [editingFolder, setEditingFolder] = useState(null);
    const [showFolderOptions, setShowFolderOptions] = useState(null);
    const folderFileInputRef = useRef(null);

    const documentCategories = [
        {
            id: 'document-vault',
            title: 'Document Vault',
            description: 'Secure storage for all documents',
            icon: FolderOpen,
            gradient: 'from-blue-500 to-blue-600',
            bgGlow: 'bg-blue-500/10',
            route: '/document-vault'
        },
        {
            id: 'opportunity-seeker',
            title: 'Opportunity Seeker',
            description: 'Job & opportunity documents',
            icon: Search,
            gradient: 'from-purple-500 to-purple-600',
            bgGlow: 'bg-purple-500/10',
            route: '/opportunity-seeker'
        },
        {
            id: 'profession',
            title: 'Profession',
            description: 'Certificates & credentials',
            icon: Briefcase,
            gradient: 'from-emerald-500 to-emerald-600',
            bgGlow: 'bg-emerald-500/10',
            route: '/profession-documents'
        },
        {
            id: 'create-folder',
            title: 'Create Folder',
            description: 'Custom organization',
            icon: FolderPlus,
            gradient: 'from-amber-500 to-orange-500',
            bgGlow: 'bg-amber-500/10',
            route: '/folder-manager'
        }
    ];

    // Document sections for each category - will be populated dynamically
    const categorySections = {
        'document-vault': [
            { id: 'personal', label: 'Personal Identity Documents', icon: User, color: 'blue' },
            { id: 'education', label: 'Educational & Academic Documents', icon: GraduationCap, color: 'green' },
            { id: 'custom', label: 'Custom Documents', icon: FolderPlus, color: 'orange' }
        ],
        'opportunity-seeker': [
            { id: 'common', label: 'Opportunity Seeker Documents', icon: FileText, color: 'purple' }
        ],
        'profession': [], // Will be populated from userProfessions
        'create-folder': [
            { id: 'common', label: 'Common Documents', icon: FileText, color: 'orange' }
        ]
    };

    // Document fields for each section
    const sectionDocuments = {
        'document-vault': {
            'personal': [
                { id: 'passport_photo', label: 'Passport Size Photo', icon: Camera, required: true },
                { id: 'signature', label: 'Signature', icon: PenTool, required: true },
                { id: 'aadhaar', label: 'Aadhaar Card', icon: CreditCard, required: true },
                { id: 'pan', label: 'PAN Card', icon: CreditCard, required: false },
                { id: 'driving_licence', label: 'Driving Licence', icon: CreditCard, required: false }
            ],
            'education': [
                { id: '10th_marksheet', label: '10th Marksheet', icon: BookOpen, required: true },
                { id: '12th_marksheet', label: '12th Marksheet', icon: BookOpen, required: true },
                { id: 'graduation_marksheet', label: 'Graduation Certificate', icon: Award, required: false }
            ],
            'custom': [] // Will be populated from customDocuments
        },
        'opportunity-seeker': {
            'common': [
                { id: 'resume_cv', label: 'Resume / CV', icon: FileText, required: true },
                { id: 'cover_letter', label: 'Cover Letter', icon: FileText, required: false },
                { id: 'experience_certificate', label: 'Experience Certificate', icon: Award, required: false },
                { id: 'internship_certificate', label: 'Internship Certificate', icon: Award, required: false },
                { id: 'project_portfolio', label: 'Project Portfolio', icon: FileText, required: false }
            ]
        },
        'profession': {
            'common': [
                { id: 'offer_letter', label: 'Offer Letter', icon: FileText, required: false },
                { id: 'experience_letter', label: 'Experience Letter', icon: Award, required: false },
                { id: 'salary_slip', label: 'Salary Slip', icon: FileText, required: false },
                { id: 'employee_id', label: 'Employee ID', icon: User, required: false }
            ]
        },
        'create-folder': {
            'common': [
                { id: 'custom_doc1', label: 'Custom Document 1', icon: FileText, required: false },
                { id: 'custom_doc2', label: 'Custom Document 2', icon: FileText, required: false }
            ]
        }
    };

    // Common documents - removed, will be shown in specific sections only
    const commonDocuments = [];

    // Profession documents configuration
    const professionDocuments = {
        'Student/Exam Aspirant': {
            icon: GraduationCap,
            color: 'blue',
            documents: [
                { id: 'student_id', label: 'Student ID Card', icon: User, required: false },
                { id: 'admit_card', label: 'Admit Card', icon: FileText, required: false },
                { id: 'enrollment_letter', label: 'Enrollment Letter', icon: FileText, required: false },
                { id: 'fee_receipt', label: 'Fee Receipt', icon: FileText, required: false }
            ]
        },
        'Working Professional': {
            icon: Briefcase,
            color: 'purple',
            documents: [
                { id: 'offer_letter', label: 'Offer Letter', icon: FileText, required: false },
                { id: 'experience_letter', label: 'Experience Letter', icon: Award, required: false },
                { id: 'salary_slip', label: 'Salary Slip', icon: FileText, required: false },
                { id: 'employee_id', label: 'Employee ID', icon: User, required: false }
            ]
        },
        'Founder': {
            icon: Lightbulb,
            color: 'orange',
            documents: [
                { id: 'pitchdeck', label: 'Pitchdeck', icon: FileText, required: false },
                { id: 'dpiit_certificate', label: 'DPIIT Certificate', icon: Award, required: false },
                { id: 'incorporation_certificate', label: 'Incorporation Certificate', icon: Building2, required: false }
            ]
        },
        'Researcher': {
            icon: FlaskConical,
            color: 'green',
            documents: [
                { id: 'research_proposal', label: 'Research Proposal (Detailed / PDF)', icon: BookOpen, required: false },
                { id: 'research_abstract', label: 'Research Abstract / Executive Summary', icon: FileText, required: false },
                { id: 'research_objectives', label: 'Research Objectives & Problem Statement', icon: Target, required: false },
                { id: 'research_methodology', label: 'Research Methodology / Approach', icon: ClipboardList, required: false }
            ]
        },
        'Service Center Operator': {
            icon: Headphones,
            color: 'cyan',
            documents: [
                { id: 'service_license', label: 'Service License', icon: Award, required: false },
                { id: 'business_registration', label: 'Business Registration', icon: Building2, required: false },
                { id: 'gst_certificate', label: 'GST Certificate', icon: FileText, required: false },
                { id: 'trade_license', label: 'Trade License', icon: FileText, required: false }
            ]
        },
        'Other': {
            icon: User,
            color: 'gray',
            documents: [
                { id: 'other_doc1', label: 'Professional Document 1', icon: FileText, required: false },
                { id: 'other_doc2', label: 'Professional Document 2', icon: FileText, required: false }
            ]
        }
    };

    // Scroll to profession section
    const scrollToProfession = (professionName) => {
        const elementId = `profession-${professionName.replace(/\s+/g, '-').toLowerCase()}`;
        const element = document.getElementById(elementId);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    };

    // Scroll to section
    const scrollToSection = (sectionId) => {
        const elementId = `section-${sectionId}`;
        const element = document.getElementById(elementId);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth', block: 'start' });
            setSelectedSection(sectionId);
        }
    };

    useEffect(() => {
        const category = searchParams.get('category');
        if (category) {
            setSelectedCategory(category);
        }
    }, [searchParams]);

    // Get user's selected professions
    useEffect(() => {
        const storedProfile = localStorage.getItem('userProfile');
        if (storedProfile) {
            try {
                const profile = JSON.parse(storedProfile);
                if (profile.profession && Array.isArray(profile.profession)) {
                    setUserProfessions(profile.profession);
                }
            } catch (e) {
                console.error('Error parsing profile:', e);
            }
        }
    }, []);

    useEffect(() => {
        // Load documents from localStorage first (works without auth)
        const savedDocs = localStorage.getItem(`uploadedDocs_${selectedCategory}`);
        if (savedDocs) {
            try {
                const docs = JSON.parse(savedDocs);
                setUploadedDocs(docs);
            } catch (e) {
                console.error("Error parsing saved documents:", e);
            }
        }

        // Check if user exists in localStorage before making API call
        const savedUser = localStorage.getItem("currentUser");

        // If no user, just continue without fetching profile (page will work without auth)
        if (!savedUser) {
            return;
        }

        if (!isProfileFetched) {
            getProfile();
        } else {
            if (savedUser) {
                try {
                    const user = JSON.parse(savedUser);
                    if (user && user.email) {
                        setUserData(user);
                        loadUploadedDocs(user);
                    }
                } catch (e) {
                    console.error("Error parsing user data:", e);
                }
            }
        }
    }, [isProfileFetched, selectedCategory, selectedSection]);

    const getProfile = async () => {
        try {
            const savedUser = localStorage.getItem("currentUser");
            if (!savedUser) return;

            const response = await api.getProfile();
            setUserData(response.user_data);
            setIsProfileFetched(true);
            localStorage.setItem("isProfileFetched", "true");
            localStorage.setItem("currentUser", JSON.stringify(response.user_data));
            loadUploadedDocs(response.user_data);
        } catch (error) {
            console.error("Failed to fetch profile:", error);
        }
    };

    const loadUploadedDocs = (user) => {
        const docs = {};
        const sections = categorySections[selectedCategory] || [];
        const allFields = [];

        // Load section-specific documents
        sections.forEach(section => {
            const sectionDocs = sectionDocuments[selectedCategory]?.[section.id] || [];
            allFields.push(...sectionDocs);
        });

        // Load common documents
        allFields.push(...commonDocuments);

        // Load custom documents
        const customDocCategories = user?.custom_doc_categories || {};
        Object.keys(customDocCategories).forEach(fieldKey => {
            if (customDocCategories[fieldKey] === selectedCategory) {
                const customDocId = fieldKey.replace('_file_url', '');
                if (!docs[customDocId]) {
                    docs[customDocId] = {
                        url: user[fieldKey],
                        name: fieldKey.replace('_file_url', '').replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase()),
                        isCustom: true
                    };
                }
            }
        });

        // Load regular documents
        allFields.forEach(field => {
            const fieldKey = `${field.id}_file_url`;
            // Fix: Check nested document_urls and all_documents as well
            let serverUrl = user[fieldKey];
            if (!serverUrl && user.document_urls) {
                serverUrl = user.document_urls[fieldKey];
            }
            if (!serverUrl && user.all_documents) {
                serverUrl = user.all_documents[fieldKey];
            }

            if (serverUrl) {
                docs[field.id] = {
                    url: serverUrl,
                    name: field.label
                };
            }
        });

        setUploadedDocs(docs);
        localStorage.setItem(`uploadedDocs_${selectedCategory}`, JSON.stringify(docs));
    };

    const getDropboxViewLink = (url) => {
        if (!url) return "";
        if (url.includes(".pdf")) {
            return url.replace("dl=0", "raw=1");
        }
        return url.replace("www.dropbox.com", "dl.dropboxusercontent.com");
    };

    const getDropboxDownloadLink = (url) => {
        if (!url) return "";
        return url
            .replace("www.dropbox.com", "dl.dropboxusercontent.com")
            .replace("&dl=0", "&dl=1");
    };

    const handleFileUpload = async (fieldId, event) => {
        const file = event.target.files[0];
        if (!file) return;

        setUploading(true);
        setUploadingField(fieldId);

        try {
            if (file.size > 10 * 1024 * 1024) {
                throw new Error("File size must be less than 10MB");
            }

            const allowedTypes = ["image/jpeg", "image/jpg", "image/png", "application/pdf"];
            if (!allowedTypes.includes(file.type)) {
                throw new Error("Please upload only JPG, PNG, or PDF files");
            }

            const objectUrl = URL.createObjectURL(file);

            const newDocs = {
                ...uploadedDocs,
                [fieldId]: {
                    url: objectUrl,
                    name: file.name,
                    file: file,
                    isLocal: true
                }
            };
            setUploadedDocs(newDocs);

            localStorage.setItem(`uploadedDocs_${selectedCategory}`, JSON.stringify({
                ...newDocs,
                [fieldId]: {
                    ...newDocs[fieldId],
                    url: objectUrl
                }
            }));

            const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");
            if (currentUser && currentUser.email) {
                try {
                    const fieldKey = `${fieldId}_file_url`;
                    const formData = new FormData();
                    formData.append('email', currentUser.email);
                    formData.append(fieldKey, file);
                    const response = await api.updateProfile(formData);
                    console.log("DEBUG: Full Upload Response:", response);
                    console.log("DEBUG: document_urls:", response?.user_data?.document_urls);
                    console.log("DEBUG: all_documents:", response?.user_data?.all_documents);
                    console.log("DEBUG: Looking for key:", fieldKey);

                    if (response && response.user_data) {
                        // Fix for Blob URL issue: Check specifically in document_urls or all_documents
                        // The backend returns document_urls nested, so checking root [fieldKey] might fail
                        let serverUrl = response.user_data[fieldKey];

                        if (!serverUrl && response.user_data.document_urls) {
                            serverUrl = response.user_data.document_urls[fieldKey];
                        }

                        if (!serverUrl && response.user_data.all_documents) {
                            serverUrl = response.user_data.all_documents[fieldKey];
                        }

                        // Fallback but only if we really can't find it (which shouldn't happen on success)
                        const finalUrl = serverUrl || objectUrl;

                        const updatedDocs = {
                            ...newDocs,
                            [fieldId]: {
                                ...newDocs[fieldId],
                                url: finalUrl,
                                isLocal: false
                            }
                        };
                        setUploadedDocs(updatedDocs);
                        localStorage.setItem(`uploadedDocs_${selectedCategory}`, JSON.stringify(updatedDocs));
                    }
                } catch (e) {
                    console.log("Server upload failed, using local storage:", e);
                }
            }

            showSuccessMessage('Document uploaded successfully!');
        } catch (error) {
            console.error("Upload error:", error);
            if (error.message && !error.message.includes("User not found") && !error.message.includes("Please log in")) {
                alert(error.message || "Failed to upload document");
            }
        } finally {
            setUploading(false);
            setUploadingField(null);
            setActiveField(null);
        }
    };

    const handleCustomFileUpload = async (customDocId, event) => {
        const file = event.target.files[0];
        if (!file) return;

        setUploading(true);
        setUploadingField(customDocId);

        try {
            if (file.size > 10 * 1024 * 1024) {
                throw new Error("File size must be less than 10MB");
            }

            const allowedTypes = ["image/jpeg", "image/jpg", "image/png", "application/pdf"];
            if (!allowedTypes.includes(file.type)) {
                throw new Error("Please upload only JPG, PNG, or PDF files");
            }

            const objectUrl = URL.createObjectURL(file);

            const newDocs = {
                ...uploadedDocs,
                [customDocId]: {
                    url: objectUrl,
                    name: customDocuments[customDocId]?.label || file.name,
                    isCustom: true,
                    file: file,
                    isLocal: true
                }
            };
            setUploadedDocs(newDocs);

            localStorage.setItem(`uploadedDocs_${selectedCategory}`, JSON.stringify({
                ...newDocs,
                [customDocId]: {
                    ...newDocs[customDocId],
                    url: objectUrl
                }
            }));

            const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");
            if (currentUser && currentUser.email) {
                try {
                    const fieldKey = `${customDocId}_file_url`;
                    const formData = new FormData();
                    formData.append('email', currentUser.email);
                    formData.append(fieldKey, file);

                    const customDocCategories = {};
                    customDocCategories[fieldKey] = selectedCategory;
                    formData.append('custom_doc_categories', JSON.stringify(customDocCategories));

                    const response = await api.updateProfile(formData);
                    if (response && response.user_data) {
                        // Fix for Blob URL issue: Check specifically in document_urls or all_documents
                        let serverUrl = response.user_data[fieldKey];

                        if (!serverUrl && response.user_data.document_urls) {
                            serverUrl = response.user_data.document_urls[fieldKey];
                        }

                        if (!serverUrl && response.user_data.all_documents) {
                            serverUrl = response.user_data.all_documents[fieldKey];
                        }

                        const finalUrl = serverUrl || objectUrl;

                        const updatedDocs = {
                            ...newDocs,
                            [customDocId]: {
                                ...newDocs[customDocId],
                                url: finalUrl,
                                isLocal: false
                            }
                        };
                        setUploadedDocs(updatedDocs);
                        localStorage.setItem(`uploadedDocs_${selectedCategory}`, JSON.stringify(updatedDocs));
                    }
                } catch (e) {
                    console.log("Server upload failed, using local storage:", e);
                }
            }

            showSuccessMessage('Document uploaded successfully!');
        } catch (error) {
            console.error("Upload error:", error);
            if (error.message && !error.message.includes("User not found") && !error.message.includes("Please log in")) {
                alert(error.message || "Failed to upload document");
            }
        } finally {
            setUploading(false);
            setUploadingField(null);
            setActiveField(null);
        }
    };

    const handleDeleteDoc = async (fieldId) => {
        if (!window.confirm("Are you sure you want to delete this document?")) return;

        try {
            const fieldKey = `${fieldId}_file_url`;
            const response = await api.deleteDocument(fieldKey);

            if (response && response.success) {
                const updated = { ...uploadedDocs };
                delete updated[fieldId];
                setUploadedDocs(updated);

                localStorage.setItem(`uploadedDocs_${selectedCategory}`, JSON.stringify(updated));

                if (customDocuments[fieldId]) {
                    setCustomDocuments(prev => {
                        const updated = { ...prev };
                        delete updated[fieldId];
                        return updated;
                    });
                }

                try {
                    await getProfile();
                } catch (e) {
                    console.log("Profile refresh skipped:", e);
                }
                showSuccessMessage('Document deleted successfully!');
            }
        } catch (error) {
            console.error("Delete error:", error);
            alert(error.message || "Failed to delete document");
        }
    };

    const triggerFileUpload = (fieldId) => {
        setActiveField(fieldId);
        fileInputRef.current?.click();
    };

    const triggerCustomFileUpload = (customDocId) => {
        setActiveField(customDocId);
        customFileInputRef.current?.click();
    };

    const handleCategoryClick = (categoryId) => {
        setSelectedCategory(categoryId);
        const sections = categorySections[categoryId] || [];
        if (sections.length > 0) {
            setSelectedSection(sections[0].id);
        } else {
            setSelectedSection('common');
        }
        navigate(`/documents?category=${categoryId}`, { replace: true });
    };

    const addCustomDocument = () => {
        if (!newCustomDocName.trim() || newCustomDocName.trim().length < 3) return;

        const customDocId = `custom_${Date.now()}`;
        const customDoc = {
            id: customDocId,
            label: newCustomDocName.trim(),
            icon: FileText,
            isCustom: true
        };

        setCustomDocuments(prev => ({
            ...prev,
            [customDocId]: customDoc
        }));

        setNewCustomDocName('');
        setShowAddCustom(false);
    };

    const removeCustomDocument = (docId) => {
        setCustomDocuments(prev => {
            const updated = { ...prev };
            delete updated[docId];
            return updated;
        });
        if (uploadedDocs[docId]) {
            handleDeleteDoc(docId);
        }
    };

    // Folder Management Functions
    const folderColors = [
        { name: 'blue', bg: 'bg-blue-500', light: 'bg-blue-100' },
        { name: 'green', bg: 'bg-green-500', light: 'bg-green-100' },
        { name: 'purple', bg: 'bg-purple-500', light: 'bg-purple-100' },
        { name: 'orange', bg: 'bg-orange-500', light: 'bg-orange-100' },
        { name: 'pink', bg: 'bg-pink-500', light: 'bg-pink-100' },
        { name: 'cyan', bg: 'bg-cyan-500', light: 'bg-cyan-100' }
    ];

    const createFolder = () => {
        if (!newFolderName.trim()) return;
        const newFolder = {
            id: Date.now(),
            name: newFolderName.trim(),
            files: [],
            color: selectedFolderColor,
            createdAt: new Date().toISOString()
        };
        const updatedFolders = [...folders, newFolder];
        setFolders(updatedFolders);
        localStorage.setItem('userFolders', JSON.stringify(updatedFolders));
        setNewFolderName('');
        setSelectedFolderColor('blue');
        setShowCreateFolderModal(false);
    };

    const deleteFolder = (folderId) => {
        const updatedFolders = folders.filter(f => f.id !== folderId);
        setFolders(updatedFolders);
        localStorage.setItem('userFolders', JSON.stringify(updatedFolders));
        setShowFolderOptions(null);
        if (currentFolder?.id === folderId) {
            setCurrentFolder(null);
        }
    };

    const renameFolder = (folderId, newName) => {
        if (!newName.trim()) return;
        const updatedFolders = folders.map(f =>
            f.id === folderId ? { ...f, name: newName.trim() } : f
        );
        setFolders(updatedFolders);
        localStorage.setItem('userFolders', JSON.stringify(updatedFolders));
        if (currentFolder?.id === folderId) {
            setCurrentFolder({ ...currentFolder, name: newName.trim() });
        }
        setEditingFolder(null);
    };

    const handleFolderFileUpload = (event) => {
        const files = Array.from(event.target.files);
        if (!currentFolder || files.length === 0) return;

        const newFiles = files.map(file => ({
            id: Date.now() + Math.random(),
            name: file.name,
            size: (file.size / 1024).toFixed(1) + ' KB',
            type: file.type,
            file: file,
            preview: file.type.startsWith('image/') ? URL.createObjectURL(file) : null,
            uploadedAt: new Date().toISOString()
        }));

        const updatedFolders = folders.map(f =>
            f.id === currentFolder.id
                ? { ...f, files: [...f.files, ...newFiles] }
                : f
        );
        setFolders(updatedFolders);
        localStorage.setItem('userFolders', JSON.stringify(updatedFolders));
        setCurrentFolder(prev => ({
            ...prev,
            files: [...prev.files, ...newFiles]
        }));
    };

    const deleteFolderFile = (fileId) => {
        const updatedFolders = folders.map(f =>
            f.id === currentFolder.id
                ? { ...f, files: f.files.filter(file => file.id !== fileId) }
                : f
        );
        setFolders(updatedFolders);
        localStorage.setItem('userFolders', JSON.stringify(updatedFolders));
        setCurrentFolder(prev => ({
            ...prev,
            files: prev.files.filter(file => file.id !== fileId)
        }));
    };

    const getFileIcon = (fileType) => {
        if (fileType?.startsWith('image/')) return Image;
        if (fileType?.includes('pdf')) return FileText;
        return File;
    };

    // Load folders from localStorage on mount
    useEffect(() => {
        if (selectedCategory === 'create-folder') {
            const saved = localStorage.getItem('userFolders');
            if (saved) {
                try {
                    const parsed = JSON.parse(saved);
                    setFolders(parsed);
                } catch (e) {
                    console.error('Error loading folders:', e);
                }
            }
        }
    }, [selectedCategory]);

    const showSuccessMessage = (message) => {
        const messageElement = document.createElement('div');
        messageElement.textContent = message;
        messageElement.style.cssText = 'position: fixed; top: 70px; right: 45%; padding: 10px; background: #4CAF50; color: white; border-radius: 4px; z-index: 1000;';
        document.body.appendChild(messageElement);
        setTimeout(() => document.body.removeChild(messageElement), 3000);
    };

    const currentCategory = documentCategories.find(cat => cat.id === selectedCategory);

    // For profession category, use user's selected professions
    let sections = categorySections[selectedCategory] || [];
    if (selectedCategory === 'profession' && userProfessions.length > 0) {
        sections = userProfessions.map(prof => ({
            id: prof.replace(/\s+/g, '-').toLowerCase(),
            label: prof,
            icon: professionDocuments[prof]?.icon || Briefcase,
            color: professionDocuments[prof]?.color || 'emerald'
        }));
    }

    // For document-vault, always add custom documents section
    if (selectedCategory === 'document-vault') {
        if (!sections.find(s => s.id === 'custom')) {
            sections.push({ id: 'custom', label: 'Custom Documents', icon: FolderPlus, color: 'orange' });
        }
    }

    // Get documents for current section
    let currentSectionDocs = [];
    if (selectedCategory === 'document-vault') {
        if (selectedSection === 'custom') {
            currentSectionDocs = Object.values(customDocuments);
        } else {
            currentSectionDocs = sectionDocuments[selectedCategory]?.[selectedSection] || [];
        }
    } else if (selectedCategory === 'profession' && userProfessions.length > 0) {
        // For profession, get documents for selected profession section
        const selectedProf = userProfessions.find(p => p.replace(/\s+/g, '-').toLowerCase() === selectedSection);
        if (selectedProf) {
            currentSectionDocs = professionDocuments[selectedProf]?.documents || [];
        }
    } else {
        currentSectionDocs = sectionDocuments[selectedCategory]?.[selectedSection] || [];
    }

    // Calculate all documents for the current category
    let allDocuments = [];
    if (selectedCategory === 'document-vault') {
        // Get all documents from personal, education, and custom sections
        const personalDocs = sectionDocuments[selectedCategory]?.['personal'] || [];
        const educationDocs = sectionDocuments[selectedCategory]?.['education'] || [];
        const customDocs = Object.values(customDocuments);
        allDocuments = [...personalDocs, ...educationDocs, ...customDocs];
    } else if (selectedCategory === 'profession' && userProfessions.length > 0) {
        // Get all documents from all selected professions
        userProfessions.forEach(prof => {
            const profDocs = professionDocuments[prof]?.documents || [];
            allDocuments = [...allDocuments, ...profDocs];
        });
        // Also include common documents
        const commonDocs = sectionDocuments[selectedCategory]?.['common'] || [];
        allDocuments = [...allDocuments, ...commonDocs];
    } else {
        // For other categories, get all documents from all sections
        const categorySections = sectionDocuments[selectedCategory] || {};
        Object.values(categorySections).forEach(sectionDocs => {
            allDocuments = [...allDocuments, ...sectionDocs];
        });
    }

    // Count uploaded documents
    const uploadedCount = Object.keys(uploadedDocs).length;
    const pendingCount = allDocuments.length - uploadedCount;

    return (
        <div className="min-h-screen bg-gradient-to-b from-slate-50 via-white to-blue-50/30">
            <div className="max-w-7xl mx-auto px-4 pt-20 pb-8 md:pt-24 md:pb-12">
                {/* Fixed Category Buttons at Top - Compact Tab Style */}
                <div className="fixed top-16 left-0 right-0 z-40 bg-white rounded-b-2xl p-3 shadow-lg border-b border-x border-gray-200 max-w-7xl mx-auto px-4" style={{ backgroundColor: '#ffffff' }}>
                    <div className="flex flex-wrap items-center justify-center gap-2 md:gap-3">
                        {documentCategories.map((category) => {
                            const IconComponent = category.icon;
                            const isActive = selectedCategory === category.id;

                            // Get specific colors for each category
                            const categoryStyles = {
                                'document-vault': {
                                    activeBg: 'bg-blue-50',
                                    activeText: 'text-blue-700',
                                    iconColor: 'text-blue-600',
                                    iconBg: 'bg-blue-100'
                                },
                                'opportunity-seeker': {
                                    activeBg: 'bg-purple-50',
                                    activeText: 'text-purple-700',
                                    iconColor: 'text-purple-600',
                                    iconBg: 'bg-purple-100'
                                },
                                'profession': {
                                    activeBg: 'bg-emerald-50',
                                    activeText: 'text-emerald-700',
                                    iconColor: 'text-emerald-600',
                                    iconBg: 'bg-emerald-100'
                                },
                                'create-folder': {
                                    activeBg: 'bg-amber-50',
                                    activeText: 'text-amber-700',
                                    iconColor: 'text-amber-600',
                                    iconBg: 'bg-amber-100'
                                }
                            };

                            const style = categoryStyles[category.id] || categoryStyles['document-vault'];

                            return (
                                <button
                                    key={category.id}
                                    onClick={() => handleCategoryClick(category.id)}
                                    className={`group relative flex items-center gap-2.5 px-4 py-2.5 rounded-xl
                                        transition-all duration-300 ease-out
                                        ${isActive
                                            ? `${style.activeBg} ${style.activeText} shadow-md`
                                            : 'bg-white text-gray-700 hover:bg-gray-50'
                                        }`}
                                >
                                    {/* Icon */}
                                    <div className={`w-8 h-8 rounded-lg flex items-center justify-center transition-colors duration-300 ${isActive ? style.iconBg : 'bg-gray-100 group-hover:bg-gray-200'
                                        }`}>
                                        <IconComponent className={`w-4 h-4 transition-colors duration-300 ${isActive ? style.iconColor : 'text-gray-600'
                                            }`} />
                                    </div>

                                    {/* Text */}
                                    <span className={`font-medium text-sm transition-colors duration-300 ${isActive ? style.activeText : 'text-gray-700'
                                        }`}>
                                        {category.title}
                                    </span>

                                    {/* Active indicator chevron */}
                                    {isActive && (
                                        <ChevronRight className={`w-4 h-4 ${style.iconColor} transition-all duration-300`} />
                                    )}
                                </button>
                            );
                        })}
                    </div>
                </div>

                {/* Main Content - Two Column Layout */}
                <div className="grid grid-cols-1 lg:grid-cols-4 gap-6 mt-8">
                    {/* Left Column - Main Content (Scrollable) */}
                    <div className="lg:col-span-3 space-y-6 overflow-y-auto max-h-[calc(100vh-12rem)] pr-2">
                        <AnimatePresence mode="wait">
                            <motion.div
                                key={selectedCategory}
                                initial={{ opacity: 0, y: 20 }}
                                animate={{ opacity: 1, y: 0 }}
                                exit={{ opacity: 0, y: -20 }}
                                transition={{ duration: 0.3 }}
                            >
                                {/* Document Vault - All sections in one container */}
                                {selectedCategory === 'document-vault' ? (
                                    <div className="bg-white rounded-3xl shadow-xl shadow-blue-900/5 p-6 md:p-8 border border-white/60">
                                        {/* Main Header */}
                                        <div className="flex items-center gap-3 mb-6">
                                            <div className="w-8 h-8 bg-blue-50 rounded-lg flex items-center justify-center">
                                                <FileText className="w-5 h-5 text-blue-600" />
                                            </div>
                                            <div>
                                                <h2 className="text-xl font-bold text-gray-900">Upload Documents</h2>
                                                <p className="text-sm text-gray-500">We recommend uploading these documents for a smooth application process.</p>
                                            </div>
                                        </div>

                                        {/* Hidden file inputs */}
                                        <input
                                            type="file"
                                            ref={fileInputRef}
                                            className="hidden"
                                            accept="image/*,.pdf"
                                            onChange={(e) => activeField && handleFileUpload(activeField, e)}
                                        />
                                        <input
                                            type="file"
                                            ref={customFileInputRef}
                                            className="hidden"
                                            accept="image/*,.pdf"
                                            onChange={(e) => activeField && handleCustomFileUpload(activeField, e)}
                                        />

                                        {/* All Sections */}
                                        <div className="space-y-8">
                                            {sections.map((section) => {
                                                const sectionDocs = section.id === 'custom'
                                                    ? Object.values(customDocuments)
                                                    : sectionDocuments[selectedCategory]?.[section.id] || [];

                                                // Skip empty custom section if no custom docs and not adding
                                                if (section.id === 'custom' && sectionDocs.length === 0 && !showAddCustom) {
                                                    return null;
                                                }

                                                return (
                                                    <div
                                                        key={section.id}
                                                        id={`section-${section.id}`}
                                                        className="scroll-mt-24"
                                                    >
                                                        {/* Section Header */}
                                                        <div className="flex items-center gap-3 mb-4">
                                                            <div className={`w-8 h-8 rounded-lg flex items-center justify-center ${section.color === 'blue' ? 'bg-blue-50' :
                                                                section.color === 'green' ? 'bg-green-50' :
                                                                    'bg-orange-50'
                                                                }`}>
                                                                <section.icon className={`w-4 h-4 ${section.color === 'blue' ? 'text-blue-600' :
                                                                    section.color === 'green' ? 'text-green-600' :
                                                                        'text-orange-600'
                                                                    }`} />
                                                            </div>
                                                            <h3 className="text-lg font-bold text-gray-900">{section.label}</h3>
                                                        </div>

                                                        {/* Document Cards Grid - UPDATED GRID AND SIZING */}
                                                        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3">
                                                            {sectionDocs.map((doc) => {
                                                                const isUploaded = uploadedDocs[doc.id];
                                                                const isUploading = uploading && uploadingField === doc.id;
                                                                const docUrl = isUploaded ? uploadedDocs[doc.id]?.url : null;
                                                                const isImage = docUrl && !docUrl.includes('.pdf');
                                                                const imgError = imgErrors[doc.id] || false;
                                                                const DocIcon = doc.icon || FileText;

                                                                return (
                                                                    <motion.div
                                                                        key={doc.id}
                                                                        initial={{ opacity: 0, y: 20 }}
                                                                        animate={{ opacity: 1, y: 0 }}
                                                                        transition={{ duration: 0.3 }}
                                                                        className="rounded-lg border border-gray-200 p-3 flex flex-col items-center hover:shadow-lg transition-all duration-300 bg-white"
                                                                    >
                                                                        <div className="mb-2 text-center font-semibold text-gray-800 text-sm flex items-center gap-2 justify-center w-full truncate">
                                                                            {doc.label}
                                                                            {doc.required && <span className="text-red-500">*</span>}
                                                                            <Info className="w-3 h-3 text-gray-400 cursor-help" />
                                                                        </div>

                                                                        {isUploaded && docUrl ? (
                                                                            <div className="w-full mb-2">
                                                                                {isImage && !imgError ? (
                                                                                    <div className="w-full h-28 rounded-lg border-2 border-green-200 overflow-hidden bg-gray-50">
                                                                                        <img
                                                                                            src={getDropboxViewLink(docUrl)}
                                                                                            alt={doc.label}
                                                                                            className="w-full h-full object-contain"
                                                                                            onError={() => setImgErrors(prev => ({ ...prev, [doc.id]: true }))}
                                                                                        />
                                                                                    </div>
                                                                                ) : (
                                                                                    <div className="w-full h-28 rounded-lg border-2 border-green-200 bg-gray-50 flex items-center justify-center">
                                                                                        <DocIcon className="w-8 h-8 text-gray-400" />
                                                                                    </div>
                                                                                )}
                                                                            </div>
                                                                        ) : (
                                                                            <label
                                                                                onClick={() => {
                                                                                    if (!isUploading) {
                                                                                        if (doc.isCustom) {
                                                                                            triggerCustomFileUpload(doc.id);
                                                                                        } else {
                                                                                            triggerFileUpload(doc.id);
                                                                                        }
                                                                                    }
                                                                                }}
                                                                                className={`w-full h-28 rounded-lg border-2 border-dashed ${isUploading
                                                                                    ? 'border-gray-300 bg-gray-50 cursor-not-allowed'
                                                                                    : 'border-green-400 bg-gradient-to-br from-green-50 via-emerald-50/50 to-green-50/30 hover:border-green-500 hover:shadow-md cursor-pointer transform hover:scale-[1.01]'
                                                                                    } flex flex-col items-center justify-center transition-all duration-300 mb-2 group relative overflow-hidden`}
                                                                            >
                                                                                {!isUploading && (
                                                                                    <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-1000"></div>
                                                                                )}
                                                                                {isUploading ? (
                                                                                    <div className="flex flex-col items-center gap-1">
                                                                                        <div className="w-6 h-6 border-2 border-green-500 border-t-transparent rounded-full animate-spin" />
                                                                                        <span className="text-xs text-gray-600 font-medium">Uploading...</span>
                                                                                    </div>
                                                                                ) : (
                                                                                    <div className="flex flex-col items-center gap-1.5 relative z-10">
                                                                                        <div className="p-2 rounded-full bg-green-100 group-hover:bg-green-200 transition-colors duration-300">
                                                                                            <Upload className="w-4 h-4 text-green-600" />
                                                                                        </div>
                                                                                        <span className="text-[10px] font-semibold text-green-700 text-center px-1">
                                                                                            Upload {doc.label}
                                                                                        </span>
                                                                                    </div>
                                                                                )}
                                                                            </label>
                                                                        )}

                                                                        <div className="flex items-center gap-2 w-full justify-center">
                                                                            {isUploaded ? (
                                                                                <>
                                                                                    <a
                                                                                        href={getDropboxViewLink(docUrl)}
                                                                                        target="_blank"
                                                                                        rel="noopener noreferrer"
                                                                                        className="px-2 py-1 bg-green-100 text-green-700 rounded-md text-[10px] font-medium hover:bg-green-200 transition-colors"
                                                                                    >
                                                                                        View
                                                                                    </a>
                                                                                    <a
                                                                                        href={getDropboxDownloadLink(docUrl)}
                                                                                        download
                                                                                        className="p-1.5 text-green-600 hover:bg-green-50 rounded-md transition-colors"
                                                                                        title="Download"
                                                                                    >
                                                                                        <Download className="w-3.5 h-3.5" />
                                                                                    </a>
                                                                                    <button
                                                                                        onClick={() => handleDeleteDoc(doc.id)}
                                                                                        className="p-1.5 text-red-500 hover:bg-red-50 rounded-md transition-colors"
                                                                                        title="Delete"
                                                                                    >
                                                                                        <Trash2 className="w-3.5 h-3.5" />
                                                                                    </button>
                                                                                </>
                                                                            ) : null}
                                                                        </div>
                                                                    </motion.div>
                                                                );
                                                            })}
                                                        </div>

                                                        {/* Add Custom Document - Only in custom section */}
                                                        {section.id === 'custom' && (
                                                            <div className="mt-6">
                                                                {showAddCustom ? (
                                                                    <div className="flex gap-2">
                                                                        <input
                                                                            type="text"
                                                                            value={newCustomDocName}
                                                                            onChange={(e) => setNewCustomDocName(e.target.value)}
                                                                            placeholder="Enter document name (min 3 characters)"
                                                                            className="flex-1 px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none"
                                                                            onKeyDown={(e) => {
                                                                                if (e.key === 'Enter') {
                                                                                    addCustomDocument();
                                                                                } else if (e.key === 'Escape') {
                                                                                    setShowAddCustom(false);
                                                                                    setNewCustomDocName('');
                                                                                }
                                                                            }}
                                                                            autoFocus
                                                                        />
                                                                        <button
                                                                            onClick={addCustomDocument}
                                                                            disabled={newCustomDocName.trim().length < 3}
                                                                            className="px-4 py-2 bg-blue-600 text-white rounded-lg font-medium hover:bg-blue-700 transition-colors disabled:bg-gray-300 disabled:cursor-not-allowed"
                                                                        >
                                                                            Add
                                                                        </button>
                                                                        <button
                                                                            onClick={() => {
                                                                                setShowAddCustom(false);
                                                                                setNewCustomDocName('');
                                                                            }}
                                                                            className="px-4 py-2 bg-gray-200 text-gray-700 rounded-lg font-medium hover:bg-gray-300 transition-colors"
                                                                        >
                                                                            Cancel
                                                                        </button>
                                                                    </div>
                                                                ) : (
                                                                    <button
                                                                        onClick={() => setShowAddCustom(true)}
                                                                        className="flex items-center gap-2 px-4 py-2 bg-orange-500 text-white rounded-lg font-medium hover:bg-orange-600 transition-colors"
                                                                    >
                                                                        <Plus className="w-4 h-4" />
                                                                        Add Custom Document
                                                                    </button>
                                                                )}
                                                            </div>
                                                        )}
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </div>
                                ) : selectedCategory === 'create-folder' ? (
                                    // File Manager for Create Folder
                                    <div className="bg-white rounded-3xl shadow-xl shadow-blue-900/5 p-6 md:p-8 border border-white/60">
                                        {/* Header */}
                                        <div className="flex items-center justify-between mb-6">
                                            <div className="flex items-center gap-3">
                                                {currentFolder && (
                                                    <button
                                                        onClick={() => setCurrentFolder(null)}
                                                        className="p-2 hover:bg-gray-100 rounded-xl transition-colors"
                                                    >
                                                        <ChevronRight className="w-5 h-5 text-gray-600 rotate-180" />
                                                    </button>
                                                )}
                                                <div>
                                                    <h2 className="text-xl font-bold text-gray-900">
                                                        {currentFolder ? currentFolder.name : 'My Folders'}
                                                    </h2>
                                                    <p className="text-sm text-gray-500">
                                                        {currentFolder
                                                            ? `${currentFolder.files.length} files`
                                                            : `${folders.length} folders`
                                                        }
                                                    </p>
                                                </div>
                                            </div>

                                            {!currentFolder ? (
                                                <button
                                                    onClick={() => setShowCreateFolderModal(true)}
                                                    className="flex items-center gap-2 px-4 py-2.5 bg-amber-600 text-white rounded-xl font-medium hover:bg-amber-700 transition-colors shadow-lg shadow-amber-600/20"
                                                >
                                                    <FolderPlus className="w-4 h-4" />
                                                    New Folder
                                                </button>
                                            ) : (
                                                <button
                                                    onClick={() => folderFileInputRef.current?.click()}
                                                    className="flex items-center gap-2 px-4 py-2.5 bg-amber-600 text-white rounded-xl font-medium hover:bg-amber-700 transition-colors shadow-lg shadow-amber-600/20"
                                                >
                                                    <Upload className="w-4 h-4" />
                                                    Upload Files
                                                </button>
                                            )}
                                        </div>

                                        {/* Hidden file input for folder files */}
                                        <input
                                            type="file"
                                            ref={folderFileInputRef}
                                            className="hidden"
                                            multiple
                                            accept="image/*,.pdf,.doc,.docx,.txt"
                                            onChange={handleFolderFileUpload}
                                        />

                                        {/* Folder Grid View or Files View */}
                                        {!currentFolder ? (
                                            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
                                                {folders.map((folder) => {
                                                    const colorClasses = folderColors.find(c => c.name === folder.color) || folderColors[0];

                                                    return (
                                                        <div key={folder.id} className="relative group">
                                                            <button
                                                                onClick={() => setCurrentFolder(folder)}
                                                                className={`w-full p-6 rounded-2xl ${colorClasses.light} border-2 border-transparent hover:border-gray-300 transition-all hover:shadow-lg active:scale-[0.98]`}
                                                            >
                                                                <div className="flex flex-col items-center gap-3">
                                                                    <div className={`w-16 h-16 ${colorClasses.bg} rounded-2xl flex items-center justify-center shadow-lg`}>
                                                                        <FolderOpen className="w-8 h-8 text-white" />
                                                                    </div>

                                                                    {editingFolder === folder.id ? (
                                                                        <input
                                                                            type="text"
                                                                            defaultValue={folder.name}
                                                                            className="text-center text-sm font-medium bg-white px-2 py-1 rounded-lg border focus:outline-none focus:ring-2 focus:ring-amber-500"
                                                                            autoFocus
                                                                            onBlur={(e) => renameFolder(folder.id, e.target.value)}
                                                                            onKeyDown={(e) => {
                                                                                if (e.key === 'Enter') {
                                                                                    renameFolder(folder.id, e.target.value);
                                                                                }
                                                                            }}
                                                                            onClick={(e) => e.stopPropagation()}
                                                                        />
                                                                    ) : (
                                                                        <span className="text-sm font-medium text-gray-800 truncate max-w-full">
                                                                            {folder.name}
                                                                        </span>
                                                                    )}

                                                                    <span className="text-xs text-gray-500">
                                                                        {folder.files.length} files
                                                                    </span>
                                                                </div>
                                                            </button>

                                                            {/* Options Menu Button */}
                                                            <button
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    setShowFolderOptions(showFolderOptions === folder.id ? null : folder.id);
                                                                }}
                                                                className="absolute top-2 right-2 p-1.5 bg-white/80 rounded-lg opacity-0 group-hover:opacity-100 transition-opacity hover:bg-white shadow-sm"
                                                            >
                                                                <ChevronRight className="w-4 h-4 text-gray-500 rotate-90" />
                                                            </button>

                                                            {/* Options Dropdown */}
                                                            {showFolderOptions === folder.id && (
                                                                <div className="absolute top-10 right-2 bg-white rounded-xl shadow-xl border border-gray-100 py-2 z-10 min-w-[140px]">
                                                                    <button
                                                                        onClick={(e) => {
                                                                            e.stopPropagation();
                                                                            setEditingFolder(folder.id);
                                                                            setShowFolderOptions(null);
                                                                        }}
                                                                        className="w-full px-4 py-2 text-left text-sm text-gray-700 hover:bg-gray-50 flex items-center gap-2"
                                                                    >
                                                                        <Edit2 className="w-4 h-4" />
                                                                        Rename
                                                                    </button>
                                                                    <button
                                                                        onClick={(e) => {
                                                                            e.stopPropagation();
                                                                            if (window.confirm('Are you sure you want to delete this folder?')) {
                                                                                deleteFolder(folder.id);
                                                                            }
                                                                        }}
                                                                        className="w-full px-4 py-2 text-left text-sm text-red-600 hover:bg-red-50 flex items-center gap-2"
                                                                    >
                                                                        <Trash2 className="w-4 h-4" />
                                                                        Delete
                                                                    </button>
                                                                </div>
                                                            )}
                                                        </div>
                                                    );
                                                })}

                                                {/* Add Folder Card */}
                                                <button
                                                    onClick={() => setShowCreateFolderModal(true)}
                                                    className="p-6 rounded-2xl border-2 border-dashed border-gray-200 hover:border-amber-400 hover:bg-amber-50/50 transition-all flex flex-col items-center justify-center gap-3 min-h-[160px]"
                                                >
                                                    <div className="w-16 h-16 bg-gray-100 rounded-2xl flex items-center justify-center">
                                                        <Plus className="w-8 h-8 text-gray-400" />
                                                    </div>
                                                    <span className="text-sm font-medium text-gray-500">Create Folder</span>
                                                </button>
                                            </div>
                                        ) : (
                                            /* Files View Inside Folder */
                                            <div>
                                                {currentFolder.files.length === 0 ? (
                                                    <div className="flex flex-col items-center justify-center py-16">
                                                        <div className="w-24 h-24 bg-gray-100 rounded-full flex items-center justify-center mb-4">
                                                            <FolderOpen className="w-12 h-12 text-gray-300" />
                                                        </div>
                                                        <h3 className="text-lg font-medium text-gray-600 mb-2">This folder is empty</h3>
                                                        <p className="text-sm text-gray-400 mb-6">Upload files to get started</p>
                                                        <button
                                                            onClick={() => folderFileInputRef.current?.click()}
                                                            className="flex items-center gap-2 px-6 py-3 bg-amber-600 text-white rounded-xl font-medium hover:bg-amber-700 transition-colors"
                                                        >
                                                            <Upload className="w-4 h-4" />
                                                            Upload Files
                                                        </button>
                                                    </div>
                                                ) : (
                                                    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
                                                        {currentFolder.files.map((file) => {
                                                            const FileIcon = getFileIcon(file.type);

                                                            return (
                                                                <div
                                                                    key={file.id}
                                                                    className="relative group p-4 rounded-2xl bg-gray-50 hover:bg-gray-100 transition-all"
                                                                >
                                                                    <div className="flex flex-col items-center gap-3">
                                                                        {file.preview ? (
                                                                            <img
                                                                                src={file.preview}
                                                                                alt={file.name}
                                                                                className="w-16 h-16 object-cover rounded-xl"
                                                                            />
                                                                        ) : (
                                                                            <div className="w-16 h-16 bg-white rounded-xl flex items-center justify-center shadow-sm">
                                                                                <FileText className="w-8 h-8 text-gray-400" />
                                                                            </div>
                                                                        )}
                                                                        <div className="text-center">
                                                                            <p className="text-sm font-medium text-gray-800 truncate max-w-[120px]">
                                                                                {file.name}
                                                                            </p>
                                                                            <p className="text-xs text-gray-400">{file.size}</p>
                                                                        </div>
                                                                    </div>

                                                                    {/* Delete button */}
                                                                    <button
                                                                        onClick={() => deleteFolderFile(file.id)}
                                                                        className="absolute top-2 right-2 p-1.5 bg-red-500 text-white rounded-lg opacity-0 group-hover:opacity-100 transition-opacity hover:bg-red-600"
                                                                    >
                                                                        <X className="w-3 h-3" />
                                                                    </button>
                                                                </div>
                                                            );
                                                        })}

                                                        {/* Add More Files */}
                                                        <button
                                                            onClick={() => folderFileInputRef.current?.click()}
                                                            className="p-4 rounded-2xl border-2 border-dashed border-gray-200 hover:border-amber-400 hover:bg-amber-50/50 transition-all flex flex-col items-center justify-center gap-2 min-h-[140px]"
                                                        >
                                                            <Upload className="w-8 h-8 text-gray-400" />
                                                            <span className="text-sm font-medium text-gray-500">Add Files</span>
                                                        </button>
                                                    </div>
                                                )}
                                            </div>
                                        )}
                                    </div>
                                ) : selectedCategory === 'profession' && userProfessions.length > 0 ? (
                                    // Profession-wise document sections - UPDATED GRID AND SIZING
                                    <div className="space-y-8">
                                        {userProfessions.map((professionName) => {
                                            const profConfig = professionDocuments[professionName];
                                            if (!profConfig) return null;

                                            const profId = professionName.replace(/\s+/g, '-').toLowerCase();
                                            const profDocs = profConfig.documents || [];
                                            const ProfIcon = profConfig.icon;

                                            return (
                                                <div
                                                    key={profId}
                                                    id={`profession-${profId}`}
                                                    className="bg-white rounded-3xl shadow-xl shadow-blue-900/5 p-6 md:p-8 border border-white/60 scroll-mt-24"
                                                >
                                                    <div className="flex items-center gap-3 mb-6">
                                                        <div className={`w-10 h-10 rounded-lg flex items-center justify-center ${profConfig.color === 'blue' ? 'bg-blue-50' :
                                                            profConfig.color === 'green' ? 'bg-green-50' :
                                                                profConfig.color === 'purple' ? 'bg-purple-50' :
                                                                    profConfig.color === 'orange' ? 'bg-orange-50' :
                                                                        profConfig.color === 'cyan' ? 'bg-cyan-50' :
                                                                            'bg-gray-50'
                                                            }`}>
                                                            <ProfIcon className={`w-5 h-5 ${profConfig.color === 'blue' ? 'text-blue-600' :
                                                                profConfig.color === 'green' ? 'text-green-600' :
                                                                    profConfig.color === 'purple' ? 'text-purple-600' :
                                                                        profConfig.color === 'orange' ? 'text-orange-600' :
                                                                            profConfig.color === 'cyan' ? 'text-cyan-600' :
                                                                                'text-gray-600'
                                                                }`} />
                                                        </div>
                                                        <div>
                                                            <h2 className="text-xl font-bold text-gray-900">{professionName}</h2>
                                                            <p className="text-sm text-gray-500">Upload documents for {professionName}</p>
                                                        </div>
                                                    </div>

                                                    {/* Document Cards Grid for this profession */}
                                                    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3">
                                                        {profDocs.map((doc) => {
                                                            const isUploaded = uploadedDocs[doc.id];
                                                            const isUploading = uploading && uploadingField === doc.id;
                                                            const docUrl = isUploaded ? uploadedDocs[doc.id]?.url : null;
                                                            const isImage = docUrl && !docUrl.includes('.pdf');
                                                            const imgError = imgErrors[doc.id] || false;
                                                            const DocIcon = doc.icon || FileText;

                                                            return (
                                                                <motion.div
                                                                    key={doc.id}
                                                                    initial={{ opacity: 0, y: 20 }}
                                                                    animate={{ opacity: 1, y: 0 }}
                                                                    transition={{ duration: 0.3 }}
                                                                    className="rounded-lg border border-gray-200 p-3 flex flex-col items-center hover:shadow-lg transition-all duration-300 bg-white"
                                                                >
                                                                    <div className="mb-2 text-center font-semibold text-gray-800 text-sm flex items-center gap-2 justify-center w-full truncate">
                                                                        {doc.label}
                                                                        {doc.required && <span className="text-red-500">*</span>}
                                                                        <Info className="w-3 h-3 text-gray-400 cursor-help" />
                                                                    </div>

                                                                    {isUploaded && docUrl ? (
                                                                        <div className="w-full mb-2">
                                                                            {isImage && !imgError ? (
                                                                                <div className="w-full h-28 rounded-lg border-2 border-green-200 overflow-hidden bg-gray-50">
                                                                                    <img
                                                                                        src={getDropboxViewLink(docUrl)}
                                                                                        alt={doc.label}
                                                                                        className="w-full h-full object-contain"
                                                                                        onError={() => setImgErrors(prev => ({ ...prev, [doc.id]: true }))}
                                                                                    />
                                                                                </div>
                                                                            ) : (
                                                                                <div className="w-full h-28 rounded-lg border-2 border-green-200 bg-gray-50 flex items-center justify-center">
                                                                                    <DocIcon className="w-8 h-8 text-gray-400" />
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    ) : (
                                                                        <label
                                                                            onClick={() => {
                                                                                if (!isUploading) {
                                                                                    triggerFileUpload(doc.id);
                                                                                }
                                                                            }}
                                                                            className={`w-full h-28 rounded-lg border-2 border-dashed ${isUploading
                                                                                ? 'border-gray-300 bg-gray-50 cursor-not-allowed'
                                                                                : 'border-green-400 bg-gradient-to-br from-green-50 via-emerald-50/50 to-green-50/30 hover:border-green-500 hover:shadow-md cursor-pointer transform hover:scale-[1.01]'
                                                                                } flex flex-col items-center justify-center transition-all duration-300 mb-2 group relative overflow-hidden`}
                                                                        >
                                                                            {!isUploading && (
                                                                                <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-1000"></div>
                                                                            )}
                                                                            {isUploading ? (
                                                                                <div className="flex flex-col items-center gap-1">
                                                                                    <div className="w-6 h-6 border-2 border-green-500 border-t-transparent rounded-full animate-spin" />
                                                                                    <span className="text-xs text-gray-600 font-medium">Uploading...</span>
                                                                                </div>
                                                                            ) : (
                                                                                <div className="flex flex-col items-center gap-1.5 relative z-10">
                                                                                    <div className="p-2 rounded-full bg-green-100 group-hover:bg-green-200 transition-colors duration-300">
                                                                                        <Upload className="w-4 h-4 text-green-600" />
                                                                                    </div>
                                                                                    <span className="text-[10px] font-semibold text-green-700 text-center px-1">
                                                                                        Upload {doc.label}
                                                                                    </span>
                                                                                </div>
                                                                            )}
                                                                        </label>
                                                                    )}

                                                                    <div className="flex items-center gap-2 w-full justify-center">
                                                                        {isUploaded ? (
                                                                            <>
                                                                                <a
                                                                                    href={getDropboxViewLink(docUrl)}
                                                                                    target="_blank"
                                                                                    rel="noopener noreferrer"
                                                                                    className="px-2 py-1 bg-green-100 text-green-700 rounded-md text-[10px] font-medium hover:bg-green-200 transition-colors"
                                                                                >
                                                                                    View
                                                                                </a>
                                                                                <a
                                                                                    href={getDropboxDownloadLink(docUrl)}
                                                                                    download
                                                                                    className="p-1.5 text-green-600 hover:bg-green-50 rounded-md transition-colors"
                                                                                    title="Download"
                                                                                >
                                                                                    <Download className="w-3.5 h-3.5" />
                                                                                </a>
                                                                                <button
                                                                                    onClick={() => handleDeleteDoc(doc.id)}
                                                                                    className="p-1.5 text-red-500 hover:bg-red-50 rounded-md transition-colors"
                                                                                    title="Delete"
                                                                                >
                                                                                    <Trash2 className="w-3.5 h-3.5" />
                                                                                </button>
                                                                            </>
                                                                        ) : null}
                                                                    </div>
                                                                </motion.div>
                                                            );
                                                        })}
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                ) : (
                                    // Regular document upload section for Opportunity Seeker - UPDATED GRID AND SIZING
                                    <div className="bg-white rounded-3xl shadow-xl shadow-blue-900/5 p-6 md:p-8 border border-white/60">
                                        <div className="flex items-center gap-3 mb-2">
                                            <div className="w-10 h-10 bg-blue-50 rounded-lg flex items-center justify-center">
                                                <FileText className="w-5 h-5 text-blue-600" />
                                            </div>
                                            <div>
                                                <h2 className="text-xl font-bold text-gray-900">Upload Documents</h2>
                                                <p className="text-sm text-gray-500">We recommend uploading these documents for a smooth application process.</p>
                                            </div>
                                        </div>

                                        {/* Hidden file inputs */}
                                        <input
                                            type="file"
                                            ref={fileInputRef}
                                            className="hidden"
                                            accept="image/*,.pdf"
                                            onChange={(e) => activeField && handleFileUpload(activeField, e)}
                                        />
                                        <input
                                            type="file"
                                            ref={customFileInputRef}
                                            className="hidden"
                                            accept="image/*,.pdf"
                                            onChange={(e) => activeField && handleCustomFileUpload(activeField, e)}
                                        />

                                        {/* Document Cards Grid */}
                                        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 mt-6">
                                            {currentSectionDocs.map((doc) => {
                                                const isUploaded = uploadedDocs[doc.id];
                                                const isUploading = uploading && uploadingField === doc.id;
                                                const docUrl = isUploaded ? uploadedDocs[doc.id]?.url : null;
                                                const isImage = docUrl && !docUrl.includes('.pdf');
                                                const imgError = imgErrors[doc.id] || false;
                                                const DocIcon = doc.icon || FileText;

                                                return (
                                                    <motion.div
                                                        key={doc.id}
                                                        initial={{ opacity: 0, y: 20 }}
                                                        animate={{ opacity: 1, y: 0 }}
                                                        transition={{ duration: 0.3 }}
                                                        className="rounded-lg border border-gray-200 p-3 flex flex-col items-center hover:shadow-lg transition-all duration-300 bg-white"
                                                    >
                                                        {/* Title with info icon */}
                                                        <div className="mb-2 text-center font-semibold text-gray-800 text-sm flex items-center gap-2 justify-center w-full truncate">
                                                            {doc.label}
                                                            {doc.required && <span className="text-red-500">*</span>}
                                                            <div className="relative inline-block">
                                                                <Info className="w-3 h-3 text-gray-400 cursor-help" />
                                                            </div>
                                                        </div>

                                                        {/* Upload Area or Preview */}
                                                        {isUploaded && docUrl ? (
                                                            <div className="w-full mb-2">
                                                                {isImage && !imgError ? (
                                                                    <div className="w-full h-28 rounded-lg border-2 border-green-200 overflow-hidden bg-gray-50">
                                                                        <img
                                                                            src={getDropboxViewLink(docUrl)}
                                                                            alt={doc.label}
                                                                            className="w-full h-full object-contain"
                                                                            onError={() => setImgErrors(prev => ({ ...prev, [doc.id]: true }))}
                                                                        />
                                                                    </div>
                                                                ) : (
                                                                    <div className="w-full h-28 rounded-lg border-2 border-green-200 bg-gray-50 flex items-center justify-center">
                                                                        <DocIcon className="w-8 h-8 text-gray-400" />
                                                                    </div>
                                                                )}
                                                            </div>
                                                        ) : (
                                                            <label
                                                                onClick={() => {
                                                                    if (!isUploading) {
                                                                        if (doc.isCustom) {
                                                                            triggerCustomFileUpload(doc.id);
                                                                        } else {
                                                                            triggerFileUpload(doc.id);
                                                                        }
                                                                    }
                                                                }}
                                                                className={`w-full h-28 rounded-lg border-2 border-dashed ${isUploading
                                                                    ? 'border-gray-300 bg-gray-50 cursor-not-allowed'
                                                                    : 'border-green-400 bg-gradient-to-br from-green-50 via-emerald-50/50 to-green-50/30 hover:border-green-500 hover:shadow-md cursor-pointer transform hover:scale-[1.01]'
                                                                    } flex flex-col items-center justify-center transition-all duration-300 mb-2 group relative overflow-hidden`}
                                                            >
                                                                {!isUploading && (
                                                                    <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-1000"></div>
                                                                )}
                                                                {isUploading ? (
                                                                    <div className="flex flex-col items-center gap-1">
                                                                        <div className="w-6 h-6 border-2 border-green-500 border-t-transparent rounded-full animate-spin" />
                                                                        <span className="text-xs text-gray-600 font-medium">Uploading...</span>
                                                                    </div>
                                                                ) : (
                                                                    <div className="flex flex-col items-center gap-1.5 relative z-10">
                                                                        <div className="p-2 rounded-full bg-green-100 group-hover:bg-green-200 transition-colors duration-300">
                                                                            <Upload className="w-4 h-4 text-green-600" />
                                                                        </div>
                                                                        <span className="text-[10px] font-semibold text-green-700 text-center px-1">
                                                                            Upload {doc.label}
                                                                        </span>
                                                                    </div>
                                                                )}
                                                            </label>
                                                        )}

                                                        {/* Action Buttons */}
                                                        <div className="flex items-center gap-2 w-full justify-center">
                                                            {isUploaded ? (
                                                                <>
                                                                    <a
                                                                        href={getDropboxViewLink(docUrl)}
                                                                        target="_blank"
                                                                        rel="noopener noreferrer"
                                                                        className="px-2 py-1 bg-green-100 text-green-700 rounded-md text-[10px] font-medium hover:bg-green-200 transition-colors"
                                                                    >
                                                                        View
                                                                    </a>
                                                                    <a
                                                                        href={getDropboxDownloadLink(docUrl)}
                                                                        download
                                                                        className="p-1.5 text-green-600 hover:bg-green-50 rounded-md transition-colors"
                                                                        title="Download"
                                                                    >
                                                                        <Download className="w-3.5 h-3.5" />
                                                                    </a>
                                                                    <button
                                                                        onClick={() => handleDeleteDoc(doc.id)}
                                                                        className="p-1.5 text-red-500 hover:bg-red-50 rounded-md transition-colors"
                                                                        title="Delete"
                                                                    >
                                                                        <Trash2 className="w-3.5 h-3.5" />
                                                                    </button>
                                                                </>
                                                            ) : null}
                                                        </div>
                                                    </motion.div>
                                                );
                                            })}
                                        </div>

                                        {/* Add Custom Document */}
                                        <div className="mt-6">
                                            {showAddCustom ? (
                                                <div className="flex gap-2">
                                                    <input
                                                        type="text"
                                                        value={newCustomDocName}
                                                        onChange={(e) => setNewCustomDocName(e.target.value)}
                                                        placeholder="Enter document name (min 3 characters)"
                                                        className="flex-1 px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none"
                                                        onKeyDown={(e) => {
                                                            if (e.key === 'Enter') {
                                                                addCustomDocument();
                                                            } else if (e.key === 'Escape') {
                                                                setShowAddCustom(false);
                                                                setNewCustomDocName('');
                                                            }
                                                        }}
                                                        autoFocus
                                                    />
                                                    <button
                                                        onClick={addCustomDocument}
                                                        disabled={newCustomDocName.trim().length < 3}
                                                        className="px-4 py-2 bg-blue-600 text-white rounded-lg font-medium hover:bg-blue-700 transition-colors disabled:bg-gray-300 disabled:cursor-not-allowed"
                                                    >
                                                        Add
                                                    </button>
                                                    <button
                                                        onClick={() => {
                                                            setShowAddCustom(false);
                                                            setNewCustomDocName('');
                                                        }}
                                                        className="px-4 py-2 bg-gray-200 text-gray-700 rounded-lg font-medium hover:bg-gray-300 transition-colors"
                                                    >
                                                        Cancel
                                                    </button>
                                                </div>
                                            ) : (
                                                <button
                                                    onClick={() => setShowAddCustom(true)}
                                                    className="flex items-center gap-2 px-4 py-2 bg-orange-500 text-white rounded-lg font-medium hover:bg-orange-600 transition-colors"
                                                >
                                                    <Plus className="w-4 h-4" />
                                                    Add Custom Document
                                                </button>
                                            )}
                                        </div>
                                    </div>
                                )}
                            </motion.div>
                        </AnimatePresence>
                    </div>

                    {/* Right Column - Side Panel (Fixed/Sticky) */}
                    <div className="lg:col-span-1">
                        <div className="bg-white rounded-3xl shadow-xl shadow-blue-900/5 p-6 border border-white/60 sticky top-28 h-fit">
                            <h3 className="text-lg font-bold text-gray-900 mb-4">Document Categories</h3>

                            <div className="space-y-3">
                                {/* Category-specific sections */}
                                {selectedCategory === 'profession' && userProfessions.length > 0 ? (
                                    // Show user's selected professions
                                    userProfessions.map((professionName) => {
                                        const profConfig = professionDocuments[professionName];
                                        if (!profConfig) return null;

                                        const ProfIcon = profConfig.icon;
                                        const profId = professionName.replace(/\s+/g, '-').toLowerCase();
                                        const iconColorClasses = {
                                            blue: 'text-blue-600',
                                            green: 'text-green-600',
                                            purple: 'text-purple-600',
                                            emerald: 'text-emerald-600',
                                            orange: 'text-orange-600',
                                            cyan: 'text-cyan-600',
                                            gray: 'text-gray-600'
                                        };
                                        const bgColorClasses = {
                                            blue: 'bg-blue-50 hover:bg-blue-100',
                                            green: 'bg-green-50 hover:bg-green-100',
                                            purple: 'bg-purple-50 hover:bg-purple-100',
                                            emerald: 'bg-emerald-50 hover:bg-emerald-100',
                                            orange: 'bg-orange-50 hover:bg-orange-100',
                                            cyan: 'bg-cyan-50 hover:bg-cyan-100',
                                            gray: 'bg-gray-50 hover:bg-gray-100'
                                        };

                                        return (
                                            <div
                                                key={profId}
                                                onClick={() => scrollToProfession(professionName)}
                                                className={`p-3 rounded-lg transition-colors cursor-pointer ${bgColorClasses[profConfig.color] || 'bg-gray-50 hover:bg-gray-100'
                                                    }`}
                                            >
                                                <div className="flex items-center gap-3">
                                                    <ProfIcon className={`w-5 h-5 ${iconColorClasses[profConfig.color] || 'text-gray-600'}`} />
                                                    <div className="flex-1">
                                                        <p className="font-medium text-gray-800 text-sm">{professionName}</p>
                                                        <p className="text-xs text-gray-500">Upload specific documents for this role.</p>
                                                    </div>
                                                    <ChevronRight className="w-4 h-4 text-gray-400" />
                                                </div>
                                            </div>
                                        );
                                    })
                                ) : (
                                    // Show regular sections for other categories
                                    sections.map((section) => {
                                        const SectionIcon = section.icon;
                                        const isActive = selectedSection === section.id;
                                        const bgColorClasses = {
                                            blue: isActive ? 'bg-blue-50 hover:bg-blue-100' : 'bg-gray-50 hover:bg-gray-100',
                                            green: isActive ? 'bg-green-50 hover:bg-green-100' : 'bg-gray-50 hover:bg-gray-100',
                                            purple: isActive ? 'bg-purple-50 hover:bg-purple-100' : 'bg-gray-50 hover:bg-gray-100',
                                            emerald: isActive ? 'bg-emerald-50 hover:bg-emerald-100' : 'bg-gray-50 hover:bg-gray-100',
                                            orange: isActive ? 'bg-orange-50 hover:bg-orange-100' : 'bg-gray-50 hover:bg-gray-100'
                                        };
                                        const iconColorClasses = {
                                            blue: 'text-blue-600',
                                            green: 'text-green-600',
                                            purple: 'text-purple-600',
                                            emerald: 'text-emerald-600',
                                            orange: 'text-orange-600'
                                        };
                                        return (
                                            <div
                                                key={section.id}
                                                onClick={() => {
                                                    if (section.id === 'custom' && Object.keys(customDocuments).length === 0 && !showAddCustom) {
                                                        setShowAddCustom(true);
                                                    }
                                                    scrollToSection(section.id);
                                                }}
                                                className={`p-3 rounded-lg transition-colors cursor-pointer ${bgColorClasses[section.color] || 'bg-gray-50 hover:bg-gray-100'
                                                    }`}
                                            >
                                                <div className="flex items-center gap-3">
                                                    <SectionIcon className={`w-5 h-5 ${iconColorClasses[section.color] || 'text-gray-600'}`} />
                                                    <div className="flex-1">
                                                        <p className="font-medium text-gray-800 text-sm">{section.label}</p>
                                                        <p className="text-xs text-gray-500">Upload specific documents for this role.</p>
                                                    </div>
                                                    <ChevronRight className="w-4 h-4 text-gray-400" />
                                                </div>
                                            </div>
                                        );
                                    })
                                )}

                                {/* Custom Documents */}
                                {Object.keys(customDocuments).length > 0 && (
                                    <div className="p-3 rounded-lg bg-orange-50 hover:bg-orange-100 transition-colors">
                                        <div className="flex items-center gap-3">
                                            <FolderPlus className="w-5 h-5 text-orange-600" />
                                            <div className="flex-1">
                                                <p className="font-medium text-gray-800 text-sm">Custom Documents</p>
                                                <p className="text-xs text-gray-500">{Object.keys(customDocuments).length} custom document(s)</p>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>

                            {/* Summary */}
                            <div className="mt-6 pt-6 border-t border-gray-200">
                                <div className="flex items-center gap-2 text-sm text-gray-600 mb-2">
                                    <FileText className="w-4 h-4" />
                                    <span>{uploadedCount} Documents Uploaded</span>
                                </div>
                                <div className="flex items-center gap-2 text-sm text-gray-600">
                                    <FileText className="w-4 h-4" />
                                    <span>{pendingCount} Documents Pending</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Security Banner */}
                <div className="mt-8 flex justify-center">
                    <div className="inline-flex items-center gap-3 px-6 py-3 bg-emerald-50 border border-emerald-200 rounded-full">
                        <Shield className="w-5 h-5 text-emerald-600" />
                        <span className="text-sm font-medium text-emerald-700">
                            Your data is secured, safe, and always in your control.
                        </span>
                    </div>
                </div>

                {/* Create Folder Modal */}
                {showCreateFolderModal && (
                    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
                        <div className="bg-white rounded-3xl p-6 w-full max-w-md shadow-2xl">
                            <div className="flex items-center justify-between mb-6">
                                <h2 className="text-xl font-bold text-gray-900">Create New Folder</h2>
                                <button
                                    onClick={() => setShowCreateFolderModal(false)}
                                    className="p-2 hover:bg-gray-100 rounded-xl transition-colors"
                                >
                                    <X className="w-5 h-5 text-gray-500" />
                                </button>
                            </div>

                            <div className="space-y-4">
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                        Folder Name
                                    </label>
                                    <input
                                        type="text"
                                        value={newFolderName}
                                        onChange={(e) => setNewFolderName(e.target.value)}
                                        placeholder="Enter folder name"
                                        className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:ring-2 focus:ring-amber-500/20 focus:border-amber-500 outline-none transition-all"
                                        autoFocus
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                createFolder();
                                            }
                                        }}
                                    />
                                </div>

                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                        Folder Color
                                    </label>
                                    <div className="flex gap-3">
                                        {folderColors.map((color) => (
                                            <button
                                                key={color.name}
                                                onClick={() => setSelectedFolderColor(color.name)}
                                                className={`w-10 h-10 rounded-xl ${color.bg} transition-all ${selectedFolderColor === color.name
                                                    ? 'ring-4 ring-offset-2 ring-gray-300 scale-110'
                                                    : 'hover:scale-105'
                                                    }`}
                                            />
                                        ))}
                                    </div>
                                </div>
                            </div>

                            <div className="flex gap-3 mt-6">
                                <button
                                    onClick={() => {
                                        setShowCreateFolderModal(false);
                                        setNewFolderName('');
                                        setSelectedFolderColor('blue');
                                    }}
                                    className="flex-1 px-4 py-3 rounded-xl border border-gray-200 text-gray-600 font-medium hover:bg-gray-50 transition-colors"
                                >
                                    Cancel
                                </button>
                                <button
                                    onClick={createFolder}
                                    disabled={!newFolderName.trim()}
                                    className="flex-1 px-4 py-3 rounded-xl bg-amber-600 text-white font-medium hover:bg-amber-700 transition-colors disabled:bg-gray-200 disabled:text-gray-400"
                                >
                                    Create Folder
                                </button>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default DocumentPage;